import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import { Auth } from 'aws-amplify';
import AWS from "aws-sdk";
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import awsmobile from "../../aws-exports";
import Layout from "../../components/common/nav/initiator/nav.component";
import { ConvertResponseForSelect, GetValueFromArray, checkDuplicates, getResponseFromKey, graphQLGetAllData, graphQLFindRecordById, removeDuplicateApprover } from '../../helper/commonfunctions';
import { Request_Status, USER_TYPES, USER_TYPES_NAMES } from '../../helper/enum';
import { ValidateAllRoleExceptAdmin } from '../../helper/validateRole';
import { EmployeeTypeEnum } from '../../models';
import Login from '../../setup/auth/login.component';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { handleNotificationsOnStatusChangeforTimeReport } from '../../components/actions/notficationActions';
// import SpinnerLoader from '../../components/common/SpinnerLoader';
import { ProgressSpinner } from 'primereact/progressspinner';
// import HtmlToPdfTimeReport from '../../components/time_report/htmlToPdf';
import * as queries from "../../graphql/queries";
import * as mutations from "../../graphql/mutations";
import { API, graphqlOperation } from 'aws-amplify';
import { useReactToPrint } from "react-to-print";
// import handleDateSelect from '../../helper/convertDateIntoPSTFormat';
// import { API, graphqlOperation } from 'aws-amplify';
// import * as mutations from '../../graphql/mutations';
import { designationForAllApps } from '../../helper/enum';
import capitalizeFirstChar from '../../components/common/capitalizeFirstChar'

const InitiateNewTimeReport = () => {

    const [previewVisible, setPreviewVisible] = useState(false);
    let [months, setMonths] = useState([]);
    let [datesLength, setDatesLength] = useState([]);
    let [totalRowspan, setTotalRowSpan] = useState(0);
    let [dates, setDates] = useState([]);
    const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);
    const [alertForChangeSchool, setAlertForChangeSchool] = useState(false);
    const [allEmployeeList, setAllEmployeeList] = useState([]);
    const [pages, setPages] = useState([]);


    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });


    let onClickPreview = async () => {

        var dates = [];
        var months = [];
        var datesLength = [];
        var totalRowspans = 0;
        let finalData = mappedData;

        const fromdate = moment(periodDates[0]).format("YYYY-MM-DD")
        const todate = periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD")
        const startDate = new Date(moment(fromdate).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));
        const endDate = new Date(moment(todate).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));

        const dateFormatter = new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        const formattedStartDate = dateFormatter.format(startDate);
        const formattedEndDate = dateFormatter.format(endDate);
        const period = `${formattedStartDate} to ${formattedEndDate}`;


        if (finalData) {
            var datesArr = [];
            var monthArr = [];
            var current = moment(startDate);
            monthArr.push(current.format('MM'));
            var end = moment(endDate);
            var templength = [];
            //datesLength[current.format('MM')] = 1
            while (current <= end) {
                datesArr.push(current.format('YYYY-MM-DD'));
                templength.push(current.format('YYYY-MM-DD'));
                if (!monthArr.includes(current.format('MM'))) {
                    monthArr.push(current.format('MM'));
                    templength = []
                    templength.push(current.format('YYYY-MM-DD'));
                } else {
                    datesLength[current.format('MM')] = templength.length
                }

                current.add(1, 'days');
            }
            dates = datesArr
            months = monthArr


            setMonths(months);
            setDatesLength(datesLength);
            setTotalRowSpan();
            setDates(dates);

            const currentDate = new Date(finalData[0].startDate);
            const lastDate = new Date(finalData[0].endDate);

            console.log(datesLength)

        }

        let empData = [];
        let empTableData = [];
        console.log("mapped Data :-", mappedData);
        let totallen = [];
        let obj = {};
        const cognito = new AWS.CognitoIdentityServiceProvider();

        for (let i = 0; i < mappedData.length; i++) {
            //---------------------------------------------
            let finalDataNew = [];
            for (let j = 0; j < dates.length; j++) {
                let getMatchDateResponse;
                if (typeof mappedData[i].employeeResponse.selectedDate != String) {
                    getMatchDateResponse = (mappedData[i].employeeResponse).filter((item) => moment(item.selectedDate).format('YYYY-MM-DD') === dates[j]);
                } else {
                    getMatchDateResponse = (mappedData[i].employeeResponse).filter((item) => item.selectedDate === dates[j]);
                }
                let data;
                if (getMatchDateResponse.length > 0) {
                    data = {
                        "date": dates[j],
                        "totalHourAndMinutesDisplay": getMatchDateResponse[0].totalHourAndMinutesDisplay,
                    }
                } else {
                    data = {
                        "date": dates[j],
                        "totalHourAndMinutesDisplay": "-",
                    }
                }
                finalDataNew.push(data);
            }
            totallen[i] = finalDataNew.length
            //---------------------------------------------

            // totallen[i] = mappedData[i].employeeResponse.length;
            // let remTd = dates.length - mappedData[i].employeeResponse.length;
            // remTd=remTd-1;

            let firstApproval;

            if (mappedData[i].employee_Id) {
                try {
                    firstApproval = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: mappedData[i].employee_Id, }).promise();
                } catch (e) {
                }
            }

            let userCodeEmp1 = firstApproval ? await GetValueFromArray(firstApproval.UserAttributes, "custom:userCode") : ''

            obj = {
                // startDate: moment(periodDates[0]).format("MM-DD-YYYY"),
                // endDate: moment(periodDates[1]).format("MM-DD-YYYY"),
                // empCode: mappedData[i].employeeId,
                // empName: mappedData[i].employeeName,
                // payRate: mappedData[i].employeePayRate,
                // employeeResponseArray: mappedData[i].employeeResponse,
                // totalWorkingHours: Math.round((mappedData[i].employeeTotalHours) * 100) / 100 + 'hrs'

                "id": mappedData[i].employeeIndex,
                "employee_Id": mappedData[i].employeeId,
                "time_Report_Id": reportId ? reportId : mappedData[i].employeeIndex,
                "pay_Rate": mappedData[i].employeePayRate,
                "totalEmployeeWorkingHours": mappedData[i].employeeTotalHours,
                // "employeeResponseArray": mappedData[i].employeeResponse,
                "employeeResponseArray": finalDataNew,
                "employeeName": mappedData[i].employeeName,
                "userCode": userCodeEmp1,
                // "restTdCount": remTd,

            }

            empTableData.push(obj);
        }

        totalRowspans = totallen.length > 0 ? totallen.sort((a, b) => b - a) : 0
        setTotalRowSpan(totalRowspans)

        let endCounter = 0;
        let pageNo = 2;
        const rows = [];
        console.log('empTableData.length', empTableData.length)
        for (let i = 16; i <= empTableData.length; i += 23) {
            endCounter = i + 23;
            rows.push({ 'start': i, 'empTableData': empTableData, 'end': endCounter, 'pageNo': pageNo++ })
        }
        setPages(rows)
        setSpecificReportDetailsView(empTableData);

        handlePrint();
    }
    const footerContent = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={() => setPreviewVisible(false)} className="p-button-text" />
            <Button label="Print" icon="pi pi-check" onClick={handlePrint} autoFocus />
        </div>
    );

    let navigateTo = useNavigate();
    const payrollEmail = process.env.REACT_APP_TimeReport_Email;
    const loggedUserId = reactLocalStorage.get('loggedUserId');
    const { reportId, EditByAP, EditBySA } = useParams();
console.log('✌️EditBySA --->', (EditByAP == "EditBySA") ? true : false);
console.log('EditBySA for cpy--->',EditByAP);

    const [allApproverList, setAllApproverList] = useState([]);
    const [budgetClerkList, setBudgetClerkList] = useState([]);


    //set static payroll hr-subcalendar@gusd.net 
    const [searchPayroll, setSearchPayroll] = useState(payrollEmail);

    //*state
    const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);

    const [selectedSchool, setSelectedSchool] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [visible, setVisible] = useState(true);
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [visibleSumbit, setVisibleSumbit] = useState(false);
    const [visibleDialogue, setVisibleDialogue] = useState(false);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [dateCount, setDateCount] = useState(0);
    const [isShowSelectedDate, setIsShowSelectedDate] = useState(false);
    const [SelectperiodExpand, setActivate] = useState("");
    const [employeeType, setEmployeeType] = useState("");
    const [employeeTypeShow, setEmployeeTypeShow] = useState("");
    const [account, setAccount] = useState("");
    const [pageNo, setPageNo] = useState("");
    const [notes, setNotes] = useState("");
    const [dailyRate, setDailyRate] = useState("");
    const [hourlyRate, setHourlyRate] = useState("");
    const [authorizingBoardReportDate, setAuthorizingBoardReportDate] = useState("");
    const [firstApproval, setFirstApproval] = useState(null);

    const [disablefirstApproval, setDisableFirstApproval] = useState(false);
    const [disableSecondApproval, setDisableSecondApproval] = useState(false);
    const [disableThirdApproval, setDisableThirdApproval] = useState(false);

    const [disablePrinciple,setDisablePrinciple]=useState(false);
    const [disableBudgetClerk,setDisableBudgetClerk]=useState(false);
    const [disableBudgetManager,setDisableBudgetManager]=useState(false);

    const [secondApproval, setSecondApproval] = useState(null);
    const [rateType, setRateType] = useState(null);
    const [isHourlyRate, setIsHourlyRate] = useState(false);
    const [isEditDates, setIsEditDates] = useState(false);
    const [isEditDateIndex, setIsEditDateIndex] = useState("");
    const [payRate, setPayRate] = useState("");
    const toggleActiveexpand = () => { setActivate(SelectperiodExpand === "SelectperiodExpand" ? "" : "SelectperiodExpand") };

    const [payrollApproval, setPayrollApproval] = useState(null);

    const [validator, setValidator] = useState(null);
    const [budgetClerk, setBudgetClerk] = useState(null);

    const [isEmpDisable, setEmpDisable] = useState(false);
    const [isAuthorizingBRDate, setIsAuthorizingBRDate] = useState(false);

    const [currentStatus, setCurrentStatus] = useState('');
    //*list
    const [periodDates, setPeriodDates] = useState([]);
    const [schoolList, setSchoolList] = useState([]);
    const [allSchoolList, setAllSchoolList] = useState([]);
    const [absentDate, setAbsentDate] = useState([]);
    const [employeeList, setEmployeeList] = useState();
    // const [approvalOneList, setApprovalOneList] = useState([]);
    // const [approvalSecondList, setApprovalSecondList] = useState([]);
    // const [validatorList, setValidatorList] = useState([]);
    const [payrollList, setPayrollList] = useState([]);
    const [updatedEmpList, setUpdatedEmpList] = useState();
    const [mappedData, setMappedData] = useState([]);
    const [selectedDateRecord, setSelectedDateRecord] = useState([]);
    console.log("selectedDateRecord:-",selectedDateRecord);

    const [users, SetUsersList] = useState([]);
    const [disabledDates, setDisabledDates] = useState([]);
    const [isValidator, setIsValidator] = useState(true);

    const [openNewEmployee, setOpenNewEmployee] = useState(false);
    const [NewEmployeeSchool, setNewEmployeeSchool] = useState(null);
    // const [NewEmployeeName, setNewEmployeeName] = useState('');

    const [timeReportIsSuperadmin, setTimeReportIsSuperadmin] = useState("");

    const [newEmpFirstName, setNewEmpFirstName] = useState('');
    const [newEmpLastName, setNewEmpLastName] = useState('');
    const rolesArray = [
        { name: 'Initiator', code: 'I' },
        { name: 'Approver', code: 'AP' },
        { name: 'Payroll', code: 'P' },
    ];
    const [newEmpSelectedRole, setNewEmpSelectedRole] = useState(null);
    const [newEmpSelectedDesignation, setNewEmpSelectedDesignation] = useState(null);

    const [NewEmployeeCode, setNewEmployeeCode] = useState('');
    const [NewEmployeeEmail, setNewEmployeeEmail] = useState('');
    const [userSub, setUserSub] = useState("");

    const [submittedBy, setSubmittedBy] = useState('');

    const particulerReportAllTransactionCycleRecord =async ()=>{
        const timeReportInitiatorResponse = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)
     
         let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: reportId } }]);
         particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));
        
        
         console.log('particulerReportAllTransactionCycleRecord :>> ', particulerReportAllTransactionCycleRecord);
        console.log('timeReportInitiatorResponse :>> ', timeReportInitiatorResponse);
        
        
        
        // if(particulerReportAllTransactionCycleRecord?.length>0){
        //     particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt))
        //     const filter1 = particulerReportAllTransactionCycleRecord.filter((ele)=>ele.to_Employee_Id===firstApproval?.code)
        //     const filter2 = particulerReportAllTransactionCycleRecord.filter((ele)=>ele.to_Employee_Id===budgetClerk?.code) 
        //     const filter3 = particulerReportAllTransactionCycleRecord.filter((ele)=>ele.to_Employee_Id===secondApproval?.code) 
        //     if(filter1.length&&filter1[0].isApproved!==false){
        //         setDisableFirstApproval(true)
        //     }
        //     if(filter2.length&&filter2[0].isApproved!==false){
        //         setDisableSecondApproval(true)
        //     }
        //     if(filter3.length&&filter3[0].isApproved!==false){
        //         setDisableThirdApproval(true)
        //     }
        // }



        if(timeReportInitiatorResponse){
            //add disable field related code here
                if (particulerReportAllTransactionCycleRecord.length) {
                    let latestEmp=particulerReportAllTransactionCycleRecord[0].to_Employee_Id;
                   
                    if(latestEmp === timeReportInitiatorResponse?.validator_id){
                        // setDisableSiteAdmin(true);
                        setDisablePrinciple(true);
                    }else if(latestEmp === timeReportInitiatorResponse?.Second_Approveal){
                        setDisablePrinciple(true);
                        setDisableBudgetClerk(true);
                    }else if(latestEmp === timeReportInitiatorResponse?.payroll_id){
                        setDisablePrinciple(true);
                        setDisableBudgetClerk(true);
                        setDisableBudgetManager(true);
                    }
                }

            // console.log("substituteCertificateRequestTransactionCycleResponse substituteCertificateRequestResponse:-",substituteCertificateRequestResponse);
            // console.log("substituteCertificateRequestTransactionCycleResponse transaction:-",substituteCertificateRequestTransactionCycleResponse);

        }
    }
    console.log('disablefirstApproval :>> ', disablefirstApproval);
    console.log('disableSecondApproval :>> ', disableSecondApproval);

    // useEffect(() => {
    //   particulerReportAllTransactionCycleRecord()
    // }, [firstApproval,budgetClerk])

    //get unique emplyee 
    const getUniqueEmployeeList = async (employeeResponses) => {
        // Grouping by email of employee in the school
        const groupedByEmail = employeeResponses.reduce((acc, obj) => {
            const email = obj.email;
            if (!acc[email]) {
                acc[email] = [];
            }
            acc[email].push(obj);

            return acc;
        }, {});

        console.log(groupedByEmail, "groupedByEmail")
        // Order each group by createdAt date in descending order
        for (const email in groupedByEmail) {
            groupedByEmail[email].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
        // Create a list with unique email addresses and the latest object for each email
        const uniqueEmailList = Object.keys(groupedByEmail).map((email) => groupedByEmail[email][0]);

        // Display the result
        console.log(uniqueEmailList, "uniqueEmailList1");
        return uniqueEmailList;
    }

    const rateTypeList = [
        {
            "name": "Daily Rate",
            "code": 1
        },
        {
            "name": "Hourly Rate",
            "code": 2
        },

    ]

    const employeeTypeList = [

        {
            "name": "Certificated",
            "code": 2
        },
        {
            "name": "Classified",
            "code": 1
        },
    ]

    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateAllRoleExceptAdmin()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }


    const SaveUserToCognito = async (newEmployeeId) => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        const userPoolId = awsmobile.aws_user_pools_id;
        const username = NewEmployeeEmail
        const password = "Gusd@2023"
        const Permanent = true

        let attributes = [
            {
                Name: 'email',
                Value: NewEmployeeEmail
            },
            {
                Name: 'custom:firstName',
                Value: newEmpFirstName
            },
            {
                Name: 'custom:lastName',
                Value: capitalizeFirstChar(newEmpLastName)
            },
            {
                Name: 'name',
                // Value: NewEmployeeName
                Value: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase()
            },
            {
                Name: 'custom:userCode',
                Value: NewEmployeeCode
            },
            // {
            //     Name: 'custom:city',
            //     Value: city
            // },
            // {
            //     Name: 'custom:mobileNumber',
            //     Value: phoneNo
            // },
            // {
            //     Name: 'custom:address',
            //     Value: addressOne
            // },
            // {
            //     Name: 'custom:stateId',
            //     Value: state
            // },
            // {
            //     Name: 'custom:countryId',
            //     Value: country
            // },
            // {
            //     Name: 'custom:userType',
            //     Value: userType.label
            // },
            {
                Name: 'custom:empId',
                Value: newEmployeeId
            },

        ];

        const params = {
            UserPoolId: userPoolId,
            Username: username,
            UserAttributes: attributes
        };

        const params2 = {
            UserPoolId: userPoolId,
            Username: username,
            Password: password,
            Permanent: Permanent,
        };

        let userSub;
        try {
            const createUserResponse = await cognito.adminCreateUser(params).promise();
            console.log('Employee confirmed and saved successfully', createUserResponse);
            userSub = createUserResponse.User?.Attributes?.find(attr => attr.Name === 'sub')?.Value;
            setUserSub(userSub)
            // toast.success("Employee confirmed and saved successfully")

            // User Confirmation 
            cognito.adminSetUserPassword(params2, (err, data) => {
                if (err) {
                    console.log('Error confirming user:', err);
                } else {
                    console.log('User confirmed successfully:', data);
                }
            });

        } catch (error) {
            toast.error("Employee already exist.")
            setOpenNewEmployee(false)
            setNewEmployeeSchool(null);
            // setNewEmployeeName("");
            setNewEmpFirstName("");
            setNewEmpLastName("");
            setNewEmpSelectedRole(null);
            setNewEmpSelectedDesignation(null);
            setNewEmployeeCode("");
            setNewEmployeeEmail("");
            console.error('Error saving Cognito user:', error);
        }



        if (userSub !== null) {
            //Update Employee with Cognito UserId
            const original = await API.graphql(
                graphqlOperation(queries.getEmployee,
                    { id: newEmployeeId }
                )
            );
            // await DataStore.query(Employee, newEmployeeId);
            await API.graphql(
                graphqlOperation(mutations.updateEmployee, {
                    input: {
                        id: original?.data?.getEmployee?.id,
                        user_Id: userSub,
                        _version: original?.data?.getEmployee?._version,
                    }
                }))
            // await DataStore.save(
            //     Employee.copyOf(original, (updated) => {
            //         updated.user_Id = userSub
            //     })
            // );
            // const original = await DataStore.query(Employee, newEmployeeId);
            // const original = await graphQLFindRecordById("getEmployee", newEmployeeId)

            // // Update record
            // await API.graphql({
            //     query: mutations.updateEmployee,
            //     variables: {
            //         input: {
            //             id: original.id,
            //             _version: original._version,
            //             user_Id: userSub
            //         }
            //     }
            // });

            /* await DataStore.save(
                Employee.copyOf(original, (updated) => {
                    updated.user_Id = userSub
                })
            ); */

        }


    }
    const fetchPaginatedRecords = async (query, filter, sort, limit, resultKey, checkDeleted = true) => {
        let allRecords = [];
        let nextToken = null;
        let variables = checkDeleted ? { _deleted: { eq: null } } : {};
        // Add to query variables that are not null
        filter && (variables.filter = filter);
        limit && (variables.limit = 3000);
        sort && (variables.sort = sort);
        do {
            variables.nextToken = nextToken;
            const result = await API.graphql(graphqlOperation(query, variables));
            const { items, nextToken: newNextToken } = result.data[resultKey];

            allRecords = [...allRecords, ...items];
            nextToken = newNextToken;
        } while (nextToken);
        return allRecords.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    };
    //search cognitousers
    const AddNewEmployee = async () => {
        if (selectedSchool === "" || selectedSchool === null) {
            toast.error("Please Select School/Department");
            return;
        }
        // else if (NewEmployeeName === null || NewEmployeeName === "") {
        //     toast.error("Please Enter Employee Name");
        //     return;
        // } 
        else if (newEmpFirstName === null || newEmpFirstName === "") {
            toast.error("Please Enter Employee First Name");
            return;
        }
        else if (newEmpLastName === null || newEmpLastName === "") {
            toast.error("Please Enter Employee Last Name");
            return;
        }
        // else if (newEmpSelectedRole === null) {
        //     toast.error("Please Select Employee Role");
        //     return;
        // }
        // else if (newEmpSelectedDesignation === null) {
        //     toast.error("Please Select Employee Designation");
        //     return;
        // }

        else if (NewEmployeeCode === "") {
            toast.error("Please Enter Employee Code");
            return;
        } else if (NewEmployeeEmail === null || NewEmployeeEmail === "") {
            toast.error("Please Enter Employee Email");
            return;
        }

        //first check typed email id is already present or not Query updated for school
        const matchedEmailRecord = await graphQLGetAllData("listEmployees", [{ email: { eq: NewEmployeeEmail } }])
        console.log(matchedEmailRecord.length, "matchedEmailRecord.length")
        const matchedEmailSchool = matchedEmailRecord.filter(item => item.school_id === selectedSchool?.code)
        console.log(matchedEmailSchool.length, "matchedEmailSchool.length")

        if (matchedEmailSchool.length == 0) {

            var AddedNewEmployee = await API.graphql(
                graphqlOperation(mutations.createEmployee,
                    {
                        input: {
                            // await DataStore.save(new Employee(
                            "school_id": selectedSchool?.code,
                            // "employee_name": NewEmployeeName,
                            firstName: newEmpFirstName.toUpperCase(),
                            lastName: capitalizeFirstChar(newEmpLastName),
                            employee_name: capitalizeFirstChar(newEmpLastName) + ", " + newEmpFirstName.toUpperCase(),
                            // role: newEmpSelectedRole?.code,
                            // designation: newEmpSelectedDesignation.code,

                            "employee_code": NewEmployeeCode,
                            "email": NewEmployeeEmail
                        }
                    }
                ))
            if (AddedNewEmployee?.data?.createEmployee?.id !== null) {
                if (matchedEmailRecord.length === 0) {
                    //Save Cognito User
                    await SaveUserToCognito(AddedNewEmployee?.data?.createEmployee?.id);
                }
            }

            if (AddedNewEmployee?.data?.createEmployee) {
                toast.success('Data Added Successfully.');
                BindList();

                try {
                    var employeeResponses = await fetchPaginatedRecords(
                        queries.listEmployees,
                        { school_id: { eq: AddedNewEmployee?.data?.createEmployee?.school_id } },
                        { field: "employee_name", direction: "asc" },
                        1000,
                        'listEmployees'
                    );
                    // { school_id: { eq: AddedNewEmployee?.data?.createEmployee?.school_id } },
                    // await DataStore.query(Employee, (c) => c.school_id.eq(AddedNewEmployee?.school_id),
                    //     {
                    //         sort: s => s.employee_name(SortDirection.ASCENDING),
                    //     }
                    // ); 
                    if (employeeResponses !== null) {
                        let employeeData = employeeResponses;
                        employeeData = await getUniqueEmployeeList(employeeData)

                        let employee = [];
                        employeeData.map((item) => {
                            let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                            let obj = {
                                name: name,
                                code: item.id
                            }
                            employee.push(obj);
                        })

                        setEmployeeList(employee);
                    }
                }
                catch (error) {
                    console.log('error --->', error);
                }

                let obj = {
                    name: (AddedNewEmployee?.data?.createEmployee?.employee_name + ' ' + '(' + AddedNewEmployee?.data?.createEmployee?.employee_code + ')'),
                    code: AddedNewEmployee?.data?.createEmployee?.id
                }

                setSelectedEmployee(obj);

                setOpenNewEmployee(false)
                setNewEmployeeSchool(null);
                // setNewEmployeeName("");
                setNewEmpFirstName("");
                setNewEmpLastName("");
                setNewEmpSelectedRole(null);
                setNewEmpSelectedDesignation(null);
                setNewEmployeeCode("");
                setNewEmployeeEmail("");
                console.log('setSelectedEmployee: ', selectedEmployee);

            }
        } else {
            toast.error("Please Use Another Email");
        }
    }

    const setEmpList = async (e, listName) => {
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "name ^= \"" + e.target.value + "\""
            };

            await cognito.listUsers(params, (err, data) => {
                if (err) {
                    //(err.message);
                } else {
                    let usersData = []
                    //let adminUsers = data.Users
                    var role = "";
                    var name = "";
                    var email = "";
                    var sub = "";
                    var usercode = "";

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        name = usercode ? `${name} (${usercode})` : name;
                        let newUser = {
                            "id": sub,
                            "name": name,
                            "email": email,
                            "code": sub,
                            "role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        }

                        usersData.push(newUser)

                        if (i === data.Users.length - 1) {
                            console.log(usersData)
                            switch (listName) {
                                /*case 'first':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    setApprovalOneList(usersData);
                                    break;
                                case 'second':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    setApprovalSecondList(usersData);
                                    break;
                                  case 'validator':
                                     usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                     setValidatorList(usersData);
                                     break; */
                                case 'payroll':
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    //setPayrollList(usersData);
                                    break;
                                case 'employee':
                                    usersData = usersData.filter(item => item.role !== "ADMIN"
                                        //  && 
                                        //  item.code !== loggedUserId
                                    );
                                    // setEmployeeList(usersData);
                                    break;

                                default:
                                    usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                                    // setApprovalSecondList(usersData);
                                    break;


                            }
                            // if(listName === 'approvalOneList'){
                            // usersData = usersData.filter(item => item.role !== "ADMIN" && item.code !== loggedUserId);
                            // setApprovalOneList(usersData);
                            // }else if(listName === 'approvalOneList'){
                            // let approverRoleList = usersData.filter(item => item.role === USER_TYPES_NAMES.AP);
                            // setAllUsersList(approverRoleList)
                            // }
                        }
                        //usersData.push({ firstName: userFirstName, lastName: userLastName, label: userFirstName + " " + userLastName, value: adminUsers[i].Username });
                    })




                }
            });


        } catch (e) {
            //toast.error(e.message);
        }
    }


    const removeDiv = (index) => {
        // Create a copy of the array to avoid modifying the state directly
        const updatedArray = [...selectedDateRecord];

        console.log(updatedArray, "updatedArray")
        // Use splice to remove the element at the specified index
        updatedArray.splice(index, 1);
        // Update the state with the modified array
        setSelectedDateRecord(updatedArray);

        let totalHour = updatedArray.map((item, index) => item.totalHourAndMinutesDisplay)
        let employeeTotalHoursResponse = totalHour.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0);

        let finalResponse = [];
        let newResponse = mappedData.map((item, index) => {
            let employeeName = item.employeeName;
            let employeeId = item.employeeId;
            let employeePayRate = item.employeePayRate
            let employeeIndex = item.employeeIndex
            let employeeResponse;
            let employeeTotalHours;
            let flag = true
            //console.log(item.employeeIndex === String(isEditDateIndex))
            if (item.employeeIndex === isEditDateIndex) {
                if (updatedArray.length === 0) {
                    console.log("match")
                    flag = false
                    setIsEditDateIndex("");
                }
                employeeResponse = updatedArray;
                employeeTotalHours = parseFloat(employeeTotalHoursResponse).toFixed(2);
            } else {
                employeeResponse = item.employeeResponse;
                employeeTotalHours = item.employeeTotalHours;
            }

            if (flag) {
                finalResponse.push(
                    {
                        "employeeName": employeeName,
                        "employeeId": employeeId,
                        "employeeResponse": employeeResponse,
                        "employeeTotalHours": employeeTotalHours,
                        "employeePayRate": employeePayRate, "employeeIndex": employeeIndex
                    })
            }

            if (index === mappedData.length - 1) {

                // console.log(employeeTotalHours,"delete1")
                // let data = [...finalResponse];
                // if (updatedArray.length === 0) {
                // console.log(employeeTotalHours,"delete")
                // data.splice(isEditDateIndex, 1);
                // setIsEditDateIndex("");
                // }

                setMappedData(finalResponse);
                // setSelectedDateRecord([]);
                setIsEditDates(false);

            }
        })

    };

    async function loadPayrollUsers() {

        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();
            var params =
            {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                "Filter": "email ^= \"" + searchPayroll + "\"",
            };
            console.log(searchPayroll)

            cognito.listUsers(params, (err, data) => {
                if (err) {
                    toast.error(err.message);
                } else {
                    var newRes = []
                    let userRole = '', userName = '', userEmail = '', userCode = '', sub = '', firstName = '', lastName = '';
                    (data.Users).forEach((user, i) => {
                        //userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        //userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        //userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                        firstName = user.Attributes.find(attr => attr.Name === "custom:firstName")?.Value;
                        lastName = user.Attributes.find(attr => attr.Name === "custom:lastName")?.Value;

                        let fullpayrollName = firstName + " " + lastName

                        let obj = {
                            "code": sub,
                            "name": fullpayrollName
                        }
                        newRes.push(obj);
                    }
                    );
                    // setPayrollList(newRes);
                    // console.log("newRes--",newRes)
                    const finalPayroll = newRes.length ? newRes[0] : newRes[0];
                    console.log("finalPayroll--", finalPayroll)
                    setPayrollApproval(finalPayroll)
                }
            });


        } catch (e) {
            toast.error(e.message);
        }
    }


    //*onClick Select Period
    const onClickDates = (date) => {
        if (selectedEmployee === null) { toast.error("Please Select Employee."); return false; }
        //sort incoming dates value
        date = date.sort((a, b) => new Date(a) - new Date(b));
        let finald = [...selectedDateRecord]


        setSelectedDateRecord([]);
        setIsShowSelectedDate(true)
        let newResponse = [];
        let selDate = [];

        let finalMapp = [...mappedData]
        let empFinalMapp = finalMapp.filter(item => item.employeeId === selectedEmployee.code)
        for (let k = 0; k < empFinalMapp.length; k++) {
            for (let j = 0; j < empFinalMapp[k].employeeResponse.length; j++) {
                selDate.push(moment(empFinalMapp[k].employeeResponse[j].selectedDate).format("MM/DD/YYYY"));
            }
        }


        if (reportId) {
            for (let i = 0; i < date.length; i++) {
                if (!selDate.includes(moment(date[i]).format("MM/DD/YYYY"))) {
                    //remove already added dates for  user
                    finald = finald.filter(item => item.selectedDate !== date[i])
                    let data = { "employeeName": selectedEmployee?.name, "selectedDate": date[i], "displayDate": date[i], "totalHour": '', "minutes": '', "totalHourAndMinutesDisplay": "" }
                    newResponse.push(data)
                }
                if (i === date.length - 1) {
                    let newdata = [...finald, ...newResponse]
                    newdata = newdata.sort((a, b) => {
                        const dateA = new Date(a.selectedDate);
                        const dateB = new Date(b.selectedDate);
                        return dateA - dateB;
                    });
                    newdata = newdata.filter((ele)=>date.includes(ele.selectedDate))
                    setSelectedDateRecord(newdata)

                }
            }

        } else if (isEditDates && !reportId) {
            for (let i = 0; i < date.length; i++) {
                finald = finald.filter(item => item.selectedDate !== date[i])
                if (!selDate.includes(moment(date[i]).format("MM/DD/YYYY"))) {

                    let data = { "employeeName": selectedEmployee.name, "selectedDate": date[i], "displayDate": date[i], "totalHour": '', "minutes": '', "totalHourAndMinutesDisplay": "" }
                    newResponse.push(data)
                }
                if (i === date.length - 1) {
                    let newdata = [...finald, ...newResponse]
                    newdata = newdata.sort((a, b) => {
                        const dateA = new Date(a.selectedDate);
                        const dateB = new Date(b.selectedDate);
                        return dateA - dateB;
                    });
                    setSelectedDateRecord(newdata)
                    //setSelectedDateRecord(newResponse)
                }

            }
        } else {
            for (let i = 0; i < date.length; i++) {
                let data = { "employeeName": selectedEmployee.name, "selectedDate": date[i], "displayDate": date[i], "totalHour": '', "minutes": '', "totalHourAndMinutesDisplay": "" }
                newResponse.push(data)
                if (i === date.length - 1) {
                    setSelectedDateRecord(newResponse)
                }
            }

        }
    };

    //*onClick Houre
    const onClickHoure = (index, value) => {
        value = value === null ? 0 : value;
        value = value > 8 ? parseFloat("8") : value


        let data = [...selectedDateRecord];
        data[index]["totalHour"] = value;
        let totalValue = data[index]["minutes"] ? (data[index]["minutes"]) : 0
        totalValue = totalValue ? (totalValue / 60).toFixed(2) : 0



        data[index]["totalHourAndMinutesDisplay"] = totalValue ? Number((value + parseFloat(totalValue)).toFixed(2)) : Number(value);
        console.log(data, "data")
        setSelectedDateRecord(data)
    };

    //*onClick Minutes
    const onClickMinutes = (index, value) => {
        value = value === null ? 0 : value;
        //{detail.hour === null + "." && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" === null ? "-" : detail.hour + "." !== null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') === null ? detail.hour : detail.hour + "." === null && Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr" !== null ? Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + "min" : detail.hour + "." + Number(detail.minute / 60).toFixed(2).slice(-2).padStart(2, '0') + " hr"}
        value = value > 59 ? 59 : value
        let totalValue = (value / 60).toFixed(2) //* 0.16666

        let data = [...selectedDateRecord];
        totalValue = data[index]["totalHour"] ? (data[index]["totalHour"] + parseFloat(totalValue)) : "." + Number(value / 60).toFixed(2).slice(-2).padStart(2, '0')

        //totalValue = value * 0.016666 + data[index]["totalHour"]

        data[index]["minutes"] = value;

        data[index]["totalHourAndMinutesDisplay"] = Number(totalValue);
        setSelectedDateRecord(data)
    };

    //onclick remove container details
    const onClickRemove = (rowData) => {
        let data = mappedData?.filter((ele)=>ele.employeeIndex!==rowData.employeeIndex);

        // data.splice(rowData.employeeIndex, 1);
        setMappedData(data);
    }

    const currentDateTime = moment();

    async function UserList(e) {
        try {
            var employeeResponses = await fetchPaginatedRecords(
                queries.listEmployees,
                null,
                { field: "employee_name", direction: "asc" },
                3000,
                'listEmployees'
            );
            // await DataStore.query(Employee, Predicates.ALL, {
            //     sort: s => s.employee_name(SortDirection.ASCENDING)
            // });

            //console.log('original->employeeResponses', employeeResponses)

            if (employeeResponses !== null) {
                //employee delete
                let employeeData = employeeResponses.filter(item => item._deleted !== true);
                employeeData=removeDuplicateApprover(employeeData);

                let employee = [];
                employeeData.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.user_Id
                    }
                    employee.push(obj);

                })
                if (e) {
                    let employeeSearchData = [];
                    employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
                    employeeSearchData = employee.filter(item => item.employee_name === e.target.value);
                    setAllApproverList(employee)
                } else {
                    setAllApproverList(employee)
                }

                console.log('original->approverRoleList', employee)

            }
        }
        catch (error) {
            console.log(error)
        }
    }

    //budget clerk
    async function setUserListByClerk(e) {
        try {
            let clerkList = allEmployeeList.filter(item => item.designation === "BUDGET_CLERK");

            if (clerkList.length) {
                let employee = [];
                clerkList.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.user_Id
                    }
                    employee.push(obj);

                })
                if (e) {
                    let employeeSearchData = [];
                    employeeSearchData = employee.filter(item => item.employee_code === e.target.value);
                    employeeSearchData = employee.filter(item => item.employee_name === e.target.value);

                    setBudgetClerkList(employee)
                } else {
                    setBudgetClerkList(employee)
                }
            }
        }
        catch (error) {
            console.log(error)
        }
    }

    const loadUsers = () => {
        //------------------------------- load users-------------
        const cognito = new AWS.CognitoIdentityServiceProvider();
        var params =
        {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };
        cognito.listUsers(params, (err, data) => {
            if (err) {
                console.log(err);
            } else {
                // console.log(data)
                SetUsersList(data.Users);
                var newRes = []
                let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                let firstName = '';
                let lastName = '';
                (data.Users).forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    firstName = user.Attributes.find(attr => attr.Name === "custom:firstName")?.Value;
                    lastName = user.Attributes.find(attr => attr.Name === "custom:lastName")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                    let obj = {
                        "userId": sub,
                        "name": ((lastName) ? lastName : '') + " " + ((firstName) ? firstName : ''), //userName
                        "email": userEmail,
                        "usercode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );

                console.log("usersWithoutAdminAndLoggedUser", newRes);
                //get only those users are without admin
                let usersWithoutAdminAndLoggedUser = [];
                const loggedUserId = reactLocalStorage.get('loggedUserId');


                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin'
                        // && 
                        // currentItem.userId !== loggedUserId  
                    ) {
                        usersWithoutAdminAndLoggedUser.push(currentItem);
                    }
                })

                //set employee list
                //let finalEmployeeList = [{ name: "No Approval Needed", code: 'no_approval_needed' }];
                let finalEmployeeList = [];


                usersWithoutAdminAndLoggedUser.map((currentItem) => {
                    let name = currentItem.usercode ? `${currentItem.name} (${currentItem.usercode})` : currentItem.name;
                    let obj = { name: name, code: currentItem.userId };
                    finalEmployeeList.push(obj);
                })


                //setEmployeeList(finalEmployeeList);

                // setApprovalOneList(finalEmployeeList);
                // setApprovalSecondList(finalEmployeeList);

                //setPayrollList(finalEmployeeList)
                // setValidatorList(finalEmployeeList)
                UserList();
                setUserListByClerk();
            }
        });

        //set static payroll user Email
        loadPayrollUsers();
    }

    async function EmployeeList(e) {
        let schoolId = e.value.code;
        setSelectedSchool(e.value);
        // setIsValidator(false)

        var SchoolResponses = allSchoolList.find(o => o.id === schoolId)

        if (SchoolResponses) {
            if (SchoolResponses.isValidator && (SchoolResponses.isValidator === true || SchoolResponses.isValidator === 'true')) {
                // setIsValidator(true)
                // console.log(isValidator ? "show" : "hide")
            }
        }
        try {

            var employeeResponses = allEmployeeList.filter(e => e.school_id !== null && e.school_id.includes(schoolId))
            employeeResponses = employeeResponses.filter(e => e._deleted !== true)

            employeeResponses = await getUniqueEmployeeList(employeeResponses)

            console.log('employeeResponses->employeeResponsesallEmployeeList', employeeResponses)

            /*  var employeeResponses = await DataStore.query(Employee, (c) => c.school_id.eq(schoolId),
                 {
                     sort: s => s.employee_name(SortDirection.ASCENDING),
                 }
             ); */

            if (employeeResponses !== null) {
                let employeeData = employeeResponses;

                let employee = [];
                employeeData.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.id
                    }
                    employee.push(obj);
                })

                setEmployeeList(employee);
                console.log('employee: ', employee);
            }
        }
        catch (error) { }

    }


    const BindList = async () => {
        // var employeeList = await DataStore.query(Employee, Predicates.ALL)
        let employeeList = await graphQLGetAllData("listEmployees");
        //employee delete
        employeeList = employeeList.filter(item => item._deleted !== true);
        employeeList = employeeList.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));

        employeeList = removeDuplicateApprover(employeeList);

        setAllEmployeeList(employeeList);
        console.log('BindList->employeeList', employeeList)
        let SchoolResponses = await graphQLGetAllData("listSchools")
        SchoolResponses = SchoolResponses.sort((a, b) => a.name.localeCompare(b.name));
        setAllSchoolList(SchoolResponses);

        var schoolArray = [];
        schoolArray = ConvertResponseForSelect(SchoolResponses);
        setSchoolList(schoolArray);
        setIsMasterDataLoaded(true)

        /*  var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
             sort: s => s.name(SortDirection.ASCENDING)
         });
         var schoolArray = []; schoolArray = ConvertResponseForSelect(SchoolResponses); setSchoolList(schoolArray); */
    }

    //*get Existing Data
    const getData = async () => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        if (reportId) {
            setVisible(false)
            if(EditByAP!=="copyReport"){
            setDisabled(true);
            setEmpDisable(true);


            if(EditByAP==="EditBySA"){
                particulerReportAllTransactionCycleRecord();
            }else{
            setDisablePrinciple(true);
            setDisableBudgetClerk(true);
            setDisableBudgetManager(true);
            }
            }

          

            let updateData = []

            var getTimeReportInitiate = await graphQLFindRecordById("getTimeReportInitiateReport", reportId);
            // var getTimeReportInitiate = await DataStore.query(TimeReportInitiateReport, reportId)
            setCurrentStatus(getTimeReportInitiate.Status ? getTimeReportInitiate.Status : '')

            if (getTimeReportInitiate.Hourly_Rate === "" && getTimeReportInitiate.rateType == 1) { setIsHourlyRate(false); setRateType({ "name": "Daily Rate", "code": 1 }) } else { setIsHourlyRate(true); setRateType({ "name": "Hourly Rate", "code": 2 }) }
            setDailyRate(getTimeReportInitiate.Daily_Rate)
            setHourlyRate(getTimeReportInitiate.Hourly_Rate)
            if (getTimeReportInitiate.Type === EmployeeTypeEnum.CERTIFICATED) { setEmployeeTypeShow({ "name": "Certificated", "code": 2 }) }
            else if (getTimeReportInitiate.Type === EmployeeTypeEnum.CLASSIFIED) { setEmployeeTypeShow({ "name": "Classified", "code": 1 }) }
            setEmployeeType(getTimeReportInitiate.Type)
            if (getTimeReportInitiate) {

                var getTimeReportEmployee = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: getTimeReportInitiate.id } }])
                // var getTimeReportEmployee = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(getTimeReportInitiate.id))  
                console.log(getTimeReportEmployee, "getTimeReportEmployee123");

                if (getTimeReportEmployee.length > 0) {

                    console.log(getTimeReportEmployee, "getTimeReportEmployee");
                    setPayRate(getTimeReportEmployee[0].pay_Rate)

                    // let adminUsers;
                    // if (getTimeReportEmployee[0].employee_Id) {
                    // try {
                    // adminUsers = await cognito.adminGetUser({
                    // UserPoolId: awsmobile.aws_user_pools_id,
                    // Username: getTimeReportEmployee[0].employee_Id,
                    // }).promise();
                    // } catch (e) {
                    //console.log(e)
                    // }
                    // }
                    // let userFirstName = adminUsers? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                    // let userLastName = adminUsers? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''

                    let fullName = ''; //userFirstName + " " + userLastName


                    // var employeeResponses1 = await DataStore.query(Employee, getTimeReportEmployee[0].employee_Id);
                    console.log(allEmployeeList, "allEmployeeList")

                    var employeeResponses1 = allEmployeeList.find(o => o.id === getTimeReportEmployee[0].employee_Id)


                    if (employeeResponses1) {
                        fullName = employeeResponses1.employee_code ? `${employeeResponses1.employee_name} (${employeeResponses1.employee_code})` : employeeResponses1.employee_name
					}

                    let obj = { name: fullName, code: getTimeReportEmployee[0].employee_Id }
                    setSelectedEmployee(obj)
					
                    //comment this for new employee code
                    //setEmployeeList([obj])

                    let newResponse = [];
                    for (var i = 0; i < getTimeReportEmployee.length; i++) {

                        let employeeResponse = await getEmployeeDetails(getTimeReportEmployee[i].id, getTimeReportEmployee[i].employee_Id);
                        // if (getTimeReportEmployee[i].employee_Id) {
                        // try {
                        // adminUsers = await cognito.adminGetUser({
                        // UserPoolId: awsmobile.aws_user_pools_id,
                        // Username: getTimeReportEmployee[i].employee_Id,
                        // }).promise();
                        // } catch (e) {
                        //console.log(e)
                        // }
                        // }
                        // let userFirstName = adminUsers? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        // let userLastName = adminUsers? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let fullName = ''; //userFirstName + " " + userLastName


                        // var employeeResponses1 = await DataStore.query(Employee, getTimeReportEmployee[i].employee_Id);

                        var employeeResponses1 = allEmployeeList.find(o => o.id === getTimeReportEmployee[i].employee_Id)

                        if (employeeResponses1) {
                            fullName = employeeResponses1.employee_code ? `${employeeResponses1.employee_name} (${employeeResponses1.employee_code})` : employeeResponses1.employee_name
                        }


                        const splitValues = getTimeReportEmployee[i].totalEmployeeWorkingHours.split('.');
                        let more3dec = 0;
                        if (splitValues.length === 1) {
                            //
                        } else {
                            more3dec = splitValues[1].length;
                        }
                        //console.log(employeeResponse)

                        let data = {
                            "employeeName": fullName,
                            "employeeId": getTimeReportEmployee[i].employee_Id,
                            "employeeResponse": employeeResponse,
                            "employeeTotalHours": more3dec ? parseFloat(getTimeReportEmployee[i].totalEmployeeWorkingHours).toFixed(2) : getTimeReportEmployee[i].totalEmployeeWorkingHours,
                            "employeePayRate": getTimeReportEmployee[i].pay_Rate,
                            "employeeIndex": i,
                        }

                        if (newResponse.length > 0) {
                            newResponse = [...newResponse, data];
                        } else {
                            newResponse.push(data)
                        }

                        if (i === getTimeReportEmployee.length - 1) {
                            setMappedData(newResponse)
							//edit Selected
							// if(obj){
							// 	let selectedEmp1 = newResponse.find(item => item.employeeId === obj.code)
							// 	onClickEdit(selectedEmp1)
							// }
					
                            setVisible(true);
                        }
                    }
                }
                else {
                    setVisible(true)
                }
            }

            //let to_date = new Date(moment(getTimeReportInitiate.To_Date).format("YYYY-MM-DD"));
            //let from_date = new Date(moment(getTimeReportInitiate.From_Date).format("YYYY-MM-DD"));

            //set date format
            let to_date = new Date(moment(getTimeReportInitiate.To_Date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));
            let from_date = new Date(moment(getTimeReportInitiate.From_Date).format('ddd MMM D YYYY HH:mm:ss [GMT]ZZ (z)'));

            console.log(getTimeReportInitiate.From_Date, "date from")

            let authorizingBoardReportDate = new Date(moment(getTimeReportInitiate.Authorizing_Board_Report_Date).format("YYYY-MM-DD"));
            setAuthorizingBoardReportDate(authorizingBoardReportDate);

            let dateArray = [from_date, to_date]; setPeriodDates(dateArray);

            // var getTimeReportOfEmployee = await DataStore.query(Schools, (c) => c.id.eq(getTimeReportInitiate.school_Department_Id))

            var getTimeReportOfEmployee = allSchoolList.find(o => o.id === getTimeReportInitiate.school_Department_Id)

            setSelectedSchool({ name: getTimeReportOfEmployee.name, code: getTimeReportOfEmployee.id })
            setAccount(getTimeReportInitiate.Account)
            setPageNo(getTimeReportInitiate.pageNo)
            setNotes(getTimeReportInitiate?.Notes)
            var employeeResponses = allEmployeeList;

            /* await DataStore.query(Employee, (c) => c.school_id.eq(getTimeReportInitiate.school_Department_Id),
                {
                    sort: s => s.employee_name(SortDirection.ASCENDING),
                }
            ); */

            if (employeeResponses) {
                //employee delete
                employeeResponses = employeeResponses.filter(item => item._deleted !== true);
                let employeeData = employeeResponses;

                let employee = [];
                employeeData.map((item) => {
                    let name = item.employee_code ? `${item.employee_name} (${item.employee_code})` : item.employee_name;
                    let obj = {
                        name: name,
                        code: item.id
                    }
                    employee.push(obj);
                })

                setEmployeeList(employee);
            }


            if (getTimeReportOfEmployee) {
                if (getTimeReportOfEmployee.isValidator && (getTimeReportOfEmployee.isValidator === true || getTimeReportOfEmployee.isValidator === 'true')) {
                    // setIsValidator(true)
                    // console.log(isValidator ? "show" : "hide")
                }
            }

            //get first Approval 
            if (getTimeReportInitiate.First_Approveal) {
                try {
                    // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(getTimeReportInitiate.First_Approveal));

                    let empName = allEmployeeList.find(o => o.user_Id === getTimeReportInitiate.First_Approveal)

                    let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;

                    let objFirst = { name: name, code: getTimeReportInitiate.First_Approveal }

                    setFirstApproval(objFirst)
                } catch (e) {
                    //console.log(e)
                }
            }

            //set cognito user list
            // setApprovalOneList([objFirst])

            //get second Approval 
            let secondApproval;
            console.log("getTimeReportInitiate:-", getTimeReportInitiate);
            if (getTimeReportInitiate.Second_Approveal) {
                try {
                    // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(getTimeReportInitiate.Second_Approveal));

                    let empName = allEmployeeList.find(o => o.user_Id === getTimeReportInitiate.Second_Approveal)

                    let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;

                    let objFirst = { name: name, code: getTimeReportInitiate.Second_Approveal }

                    console.log("getTimeReportInitiate empName obj:-", objFirst);
                    setSecondApproval(objFirst)
                } catch (e) {
                    //console.log(e)
                }
            }

            //set cognito user list
            // setApprovalSecondList([objSecond])

            //get  payroll 
            let getpayroll;
            if (getTimeReportInitiate.payroll_id) {

                let empName = allEmployeeList.find(o => o.user_Id === getTimeReportInitiate.payroll_id)
                let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;
                let objFirst = { name: name, code: getTimeReportInitiate.payroll_id }

                setPayrollApproval(objFirst)
                //set cognito user list
                // setPayrollList([objFirst])
            }

            //get  validator 
            let getvalidator;
            if (getTimeReportInitiate.validator_id) {

                // let empName = await DataStore.query(Employee, (c) => c.user_Id.eq(getTimeReportInitiate.validator_id));
                let empName = allEmployeeList.find(o => o.user_Id === getTimeReportInitiate.validator_id)

                let name = empName.employee_code ? `${empName.employee_name} (${empName.employee_code})` : empName.employee_name;

                let objValidator = { name: name, code: getTimeReportInitiate.validator_id }
                // setValidator(objValidator)
                setBudgetClerk(objValidator);
                //set cognito user list
                // setValidatorList([objValidator])

            }

        }
    }



    //*All state clear
    const getEmployeeDetails = async (timeReportEmployeeDetailsId, employeeId) => {

        const cognito = new AWS.CognitoIdentityServiceProvider();
        let newResponse = [];
        // var timeReportEmployeeDetails = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmployeeDetailsId))
        var timeReportEmployeeDetails = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: timeReportEmployeeDetailsId } }])

        for (var i = 0; i < timeReportEmployeeDetails.length; i++) {

            let employeeName = "";
            try {
                employeeName = await cognito.adminGetUser({
                    UserPoolId: awsmobile.aws_user_pools_id,
                    Username: employeeId,
                }).promise();
            } catch (e) {
                //console.log(e)
            }
            let userFirstName = await GetValueFromArray(employeeName.UserAttributes, "custom:firstName")
            let userLastName = await GetValueFromArray(employeeName.UserAttributes, "custom:lastName")
            let fullName = userFirstName + " " + userLastName

            newResponse.push({ "employeeName": fullName, "selectedDate": timeReportEmployeeDetails[i].date, "displayDate": timeReportEmployeeDetails[i].date, "totalHour": timeReportEmployeeDetails[i].totalHours, "minutes": timeReportEmployeeDetails[i].totalMin, "totalHourAndMinutesDisplay": timeReportEmployeeDetails[i].totalHoursAndMinDisplay })
            if (i === timeReportEmployeeDetails.length - 1) {
                return newResponse
            }
        }
    };

    //All state clear
    const stateClear = () => {
        setAbsentDate([]);
        setSelectedEmployee(null);
        setPayRate("");
    };

    //Create  Initiate New Report
    const applyReport = async () => {
        //*check total hours fill
        var checkTotalHours = selectedDateRecord.filter((item) => item.totalHour !== "" && item.totalHour !== null ? item : null);
        //*check total minutes fill
        var checkTotalMinutes = selectedDateRecord.filter((item) => item.minutes !== "" && item.minutes !== null ? item : null);

        setDisabled(true)
        if (selectedSchool === null) { toast.error("Please Select School."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }
        if (selectedEmployee === null) { toast.error("Please Select Employee."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }
        if (periodDates.length === null) { toast.error("Please Select Period."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }
        if (firstApproval === null) { toast.error("Please Select Principle/Dept Head."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }

        if (authorizingBoardReportDate === null || authorizingBoardReportDate === '') { toast.error("Please Select Authorizing Board Report Date."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }

        if (payrollApproval === null || payrollApproval === '') { toast.error("Please Select Payroll."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }

        if (budgetClerk) {
            if (secondApproval === null) {
                toast.error("Please Select Budget Manager."); return false;
            }
        }

        // if (isValidator) {

        //     if (secondApproval === null) { toast.error("Please Select Second Approval."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }

        //     if (validator === null) { toast.error("Please Select Validator."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }

        // }

        //The second approval is not mandatory
        //	   if (secondApproval === null) { toast.error("Please Select Second Approval."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }
        let testFlag = true

        for (let i = 0; i < selectedDateRecord.length; i++) {
            if (selectedDateRecord[i].totalHour == "" || selectedDateRecord[i].totalHour == null) {

                if (selectedDateRecord[i].minutes == "" || selectedDateRecord[i].minutes == null) {
                    toast.error("Please Enter Total Minutes.");
                    setVisible(true);
                    return false;

                } else {
                    if (reportId) { setVisible(true); } else { setVisible(false); }
                }
            } else {
                if (reportId) { setVisible(true); } else { setVisible(false); }
            }
        }

        // if (checkTotalHours.length !== selectedDateRecord.length) {
        // if (checkTotalMinutes.length !== selectedDateRecord.length) { toast.error("Please Enter Total Minutes."); return false; } else {  testFlag = false;  if (reportId) { setVisible(true); } else { setVisible(false); } }
        // }
        // if(testFlag){
        // if (checkTotalHours.length !== selectedDateRecord.length) { toast.error("Please Enter Total Hours."); return false; } else { if (reportId) { setVisible(true); } else { setVisible(false); } }
        // }
        console.log(isEditDates)
        if (isEditDates) {
            let totalHour = selectedDateRecord.map((item, index) => item.totalHourAndMinutesDisplay)
            let employeeTotalHoursResponse = totalHour.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0);
            // let more3dec = 0;
            // if (splitValues.length === 1) {

            // } else {
            // more3dec = splitValues[1].length;
            // }
            //employeeTotalHoursResponse = parseFloat(employeeTotalHoursResponse).toFixed(2)
            // let totalHour1 = selectedDateRecord.map((item, index) => item.totalHour)
            // let h1 = totalHour1.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0);
            // let totalmin = selectedDateRecord.map((item, index) => item.minutes)
            // let m1 = totalmin.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0);
            //////////console.log(m1)
            // m1 = m1/60

            //console.log(selectedDateRecord)
            let finalResponse = [];
            let newResponse = mappedData.map((item, index) => {
                let employeeName = item.employeeName;
                let employeeId = item.employeeId;
                let employeePayRate = item.employeePayRate
                let employeeIndex = item.employeeIndex
                let employeeResponse;
                let employeeTotalHours;
                //console.log(item.employeeIndex === String(isEditDateIndex))
                if (item.employeeIndex === isEditDateIndex) {
                    employeeResponse = selectedDateRecord;
                    employeeTotalHours = parseFloat(employeeTotalHoursResponse).toFixed(2);
                } else {
                    employeeResponse = item.employeeResponse;
                    employeeTotalHours = item.employeeTotalHours;
                }
                finalResponse.push({ "employeeName": employeeName, "employeeId": employeeId, "employeeResponse": employeeResponse, "employeeTotalHours": employeeTotalHours, "employeePayRate": employeePayRate, "employeeIndex": employeeIndex })
                if (index === mappedData.length - 1) {

                    setMappedData(finalResponse);
                    setSelectedDateRecord([]);
                    setIsEditDates(false);
                    setIsEditDateIndex("");
                }
            })

        } else {
            //*set data to table
            if (mappedData.length > 0) {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKey(data, removeDuplicateArray, selectedEmployee.code, payRate);

                let object = getResponse[0];
                let myArray = [...mappedData, object];
                //
                if (reportId) {
                    let updatedData = mappedData.filter(item => item.employeeId !== selectedEmployee.code);
                    let object2 = []

                    object2 = getResponse;
                    myArray = [...updatedData, ...object2];
                }
                const groupedData = myArray.reduce((acc, obj) => {
                    const existingObj = acc.find(item => item.employeeId === obj.employeeId);
                    if (existingObj) { existingObj.employeeResponse.push(...obj.employeeResponse); }
                    else { acc.push(obj); }
                    return acc;
                }, []);

                //

                let newResponse = groupedData.map((item, index) => { return { ...item, employeeIndex: String(index) }; })
                const sortedUsers = newResponse.sort((a, b) => a.employeeName.localeCompare(b.employeeName));

                for (let i = 0; i < sortedUsers.length; i++) {
                    sortedUsers[i].employeeTotalHours = parseFloat(sortedUsers[i].employeeTotalHours).toFixed(2)
                }
                setMappedData(sortedUsers);
                setSelectedDateRecord([]);
            } else {
                let data = selectedDateRecord
                let getEmployeeNames = data.map((item) => item.employeeName)
                let removeDuplicateArray = checkDuplicates(getEmployeeNames)
                const getResponse = await getResponseFromKey(data, removeDuplicateArray, selectedEmployee.code, payRate)
                let newResponse = getResponse.map((item, index) => { return { ...item, employeeIndex: String(index) }; })
                setMappedData(newResponse);
                setSelectedDateRecord([]);
            }
        }

        // //disable date 
        // let datesArray = []
        // for (let i = 0; i < selectedDateRecord.length; i++) {
        //     datesArray[i] = selectedDateRecord[i].selectedDate
        // }
        // //let date
        // let updatedList = [...disabledDates, ...datesArray]
        // setDisabledDates(updatedList)

        setVisible(true);
        stateClear()
        //added for edit and onchange conflict
        setIsEditDates(false)

    }

    const goBack = () => {
        navigateTo((EditByAP == "EditBySA") ? "/time_report/SuperAdminDashboard" : "/time_report");
    }

    //*save Report
    const saveReport = async (status) => {

        // alert(status);

        setPleaseWaitButton(false);
        //if (mappedData.length === 0) { toast.error("Please select employee data"); return }

        if (account == "") { toast.error("Please Enter Account # Number"); setEmpDisable(false); return }
        else if (rateType === null) { toast.error("Please Select Rate Type."); setEmpDisable(false); return }
        else if (pageNo === "") { toast.error("Please Select pageNo."); setEmpDisable(false); return }
        else if (!isHourlyRate && dailyRate === "") { toast.error("Please Select Daily Rate."); setEmpDisable(false); return }
        else if (firstApproval === null) { toast.error("Please Select  Principal/ Dept Head.."); setEmpDisable(false); return }

        if (budgetClerk) {
            if (secondApproval === null) { toast.error("Please Select Budget Manager."); return false; }
        }

        //return
        if (reportId) {

             //on submit check if period and dates are matched or not
             if(status === Request_Status.S){
                
                //check employees dates is matched with period or not
                const timeReportInitiatorResponse = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)
               
                if(mappedData.length){        
                    let sortedData=[];
                            let startDate=moment(periodDates[0]).format('MM/DD/YYYY');
                            let endDate=moment(periodDates[1]).format('MM/DD/YYYY');
                            let inValidRecordCount=0;
                            let inValidRecord=[];
                            mappedData.map(data=>{
                
                                let particularEmpDates=data.employeeResponse;
                                let commonWrong=false;
                                for(let i=0;i<particularEmpDates.length;i++){
                
                                    let selectedDate=moment(particularEmpDates[i].selectedDate).format('MM/DD/YYYY');
                
                                    if(selectedDate >= startDate && selectedDate <= endDate){
                                        particularEmpDates[i].isWrong=false;
                                    }else{
                                        inValidRecordCount++;
                                        particularEmpDates[i].isWrong=true;
                                        commonWrong=true;
                                        inValidRecord.push(particularEmpDates[i].selectedDate);
                                    }
                                }
                                data.isCommonWrong=commonWrong;
                                sortedData.push(data);                
                            })
                        
                            if(inValidRecordCount > 0){
                                setAbsentDate(inValidRecord);
                                setMappedData(sortedData);
                                toast.error("Please make necessary date modifications before submitting the form");
                                return;
                            }}
            }
            if(EditByAP==="copyReport"){
                CommenFunction(status)
            }else{

            //------------------------------------------------------------------------------
            //check if that particular report Id status have TimeReportInitiateReport table.
            try {

                let timeReportInitiatorResponse = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)
                
                if (timeReportInitiatorResponse.Status === "APPROVAL_REJECTED") {
                    // alert("after rejection");
                    
                    let updateTimeReportInitiateReportData;
                    if(EditByAP==="EditBySA"){
                        // alert("after rejection in");
                      

                        updateTimeReportInitiateReportData = await API.graphql({
                            query: mutations.updateTimeReportInitiateReport,
                            variables: {
                                input: {
                                    id: timeReportInitiatorResponse.id,
                                    _version: timeReportInitiatorResponse._version,
                                    Status: 'RESUBMITTED',


                                    school_Department_Id: selectedSchool.code,
                                    From_Date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                    To_Date: periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                                    Type: employeeType,
                                    Account: account,
                                    pageNo: pageNo,
                                    Hourly_Rate: hourlyRate,
                                    Daily_Rate: dailyRate,
                                    Authorizing_Board_Report_Date: moment(authorizingBoardReportDate).format("YYYY-MM-DD"),

                                    First_Approveal: firstApproval.code,
                                    validator_id: budgetClerk ? budgetClerk.code : '',
                                    Second_Approveal: secondApproval ? secondApproval.code : '',  //budget Manager which is validator
                                    payroll_id: payrollApproval ? payrollApproval.code : '',

                        
                                    Notes: notes,
                        // Created_By: loggedUserId,
                        // Created_By_Date: moment(currentDateTime).toISOString(),
                        // rateType: rateType?.code

                                }
                            }
                        });
                    

                    }else
                    {

                    //then this particular request came for reviewed and resubmit.
                    updateTimeReportInitiateReportData = await API.graphql({
                        query: mutations.updateTimeReportInitiateReport,
                        variables: {
                            input: {
                                id: timeReportInitiatorResponse.id,
                                _version: timeReportInitiatorResponse._version,
                                Status: 'RESUBMITTED'
                            }
                        }
                    });
                    }

                    console.log('✌️updateTimeReportInitiateReportData --->', updateTimeReportInitiateReportData);
                    let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id } }])
console.log('✌️TimeReportEmployeesResponse --->', TimeReportEmployeesResponse);
if(TimeReportEmployeesResponse.length){

    for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {

        let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)

        var deletedData = await API.graphql({
            query: mutations.deleteTimeReportEmployee,
            variables: {
                input: {
                    id: timeReportEmployeeData.id,
                    _version: timeReportEmployeeData._version
                }
            }
        });
        console.log('✌️deletedData --->', deletedData);
        let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])
console.log('✌️TimeReportEmployeesDetailsResponse --->', TimeReportEmployeesDetailsResponse);

for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
    // let timeReportEmployeeDetail = await graphQLFindRecordById("getTimeReportEmployeeDetail", TimeReportEmployeesDetailsResponse[k].id)
    // console.log('TimeReportEmployeesDetailsResponse timeReportEmployeeDetail', timeReportEmployeeDetail)
    // if (timeReportEmployeeDetail) {
        var deletedEmployeeData = await API.graphql({
            query: mutations.deleteTimeReportEmployeeDetails,
            variables: {
                input: {
                    id: TimeReportEmployeesDetailsResponse[k].id,
                    _version: TimeReportEmployeesDetailsResponse[k]._version
                }
            }
        });
    // }
}
    }
}

                    for (var i = 0; i < mappedData.length; i++) {
                        //Save TimeReportEmployee
                        var timeReportEmployeeResponse = await API.graphql(
                            graphqlOperation(mutations.createTimeReportEmployee, {
                                input: {
                                    employee_Id: mappedData[i].employeeId,
                                    time_Report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                    pay_Rate: String(mappedData[i].employeePayRate),
                                    totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                                }
                            })
                        );

                        saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse)

                        if (i === mappedData.length - 1) {
                            toast.success('Data Edited Successfully.');
                            // { goBack() }
                        }
                    }

                    let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: reportId } }]);
                    particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));
                    
                    if(EditByAP==="EditBySA"){
                        var updateTransactionCycle = await API.graphql(
                            graphqlOperation(mutations.updateTimeReportTransactionCycle, {
                                input: {
                                    id: particulerReportAllTransactionCycleRecord[0].id,
                                    _version:particulerReportAllTransactionCycleRecord[0]._version,
                                    status: 'Reviewed and Resubmitted',
                                    customUpdatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                                    to_Employee_Id:loggedUserId
                                }
                            })
                        );
                    }else{
                    var updateTransactionCycle = await API.graphql(
                        graphqlOperation(mutations.updateTimeReportTransactionCycle, {
                            input: {
                                id: particulerReportAllTransactionCycleRecord[0].id,
                                _version:particulerReportAllTransactionCycleRecord[0]._version,
                                status: 'Reviewed and Resubmitted',
                                customUpdatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                                to_Employee_Id:timeReportInitiatorResponse?.Created_By
                            }
                        })
                    );
                    }

                    var addNewRowForFirstAppResponse = await API.graphql(
                        graphqlOperation(mutations.createTimeReportTransactionCycle, {
                            input: {
                                report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                from_Employee_Id: loggedUserId,
                                to_Employee_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.First_Approveal,
                                status: 'Open',
                                isApproved: false,
                                remark: '',
                                date: moment().format("YYYY-MM-DD"),
                                approver_level: ''
                            }
                        })
                    );

                    if(EditByAP==="EditBySA"){
                    await handleNotificationsOnStatusChangeforTimeReport('OPEN', timeReportInitiatorResponse.id, "TIME_REPORT", updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.First_Approveal, timeReportInitiatorResponse.Created_By);
                    }
                     
                    { goBack() }
                    // }
                } else if (timeReportInitiatorResponse.Status === "RESUBMITTED") {


                    if (EditByAP == "EditByAP") {
                        // console.log("timeReportInitiatorResponse.id:-", timeReportInitiatorResponse.id);

                        try {
                            // Update record
                            var updateTimeReportInitiateReportData = await API.graphql({
                                query: mutations.updateTimeReportInitiateReport,
                                variables: {
                                    input: {
                                        id: timeReportInitiatorResponse.id,
                                        _version: timeReportInitiatorResponse._version,
                                        // Status: 'RESUBMITTED'

                                        school_Department_Id: selectedSchool.code,
                                        From_Date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                        To_Date: periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                                        Type: employeeType,
                                        Account: account,
                                        pageNo: pageNo,
                                        Hourly_Rate: hourlyRate,
                                        Daily_Rate: dailyRate,
                                        Authorizing_Board_Report_Date: moment(authorizingBoardReportDate).format("YYYY-MM-DD"),
                                        Notes: notes,
                                        rateType: rateType?.code,

                                        // First_Approveal: firstApproval.code,
                                        // validator_id: budgetClerk ? budgetClerk.code : '',
                                        // Second_Approveal: secondApproval ? secondApproval.code : '',  //budget Manager which is validator
                                        // payroll_id: payrollApproval ? payrollApproval.code : '',
                                        // Created_By: loggedUserId,
                                        // Created_By_Date: moment(currentDateTime).toISOString(),
                                    }
                                }
                            });


                            //-------------------------------------------
                            if (updateTimeReportInitiateReportData) {
                                //delete old employees
                                let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id } }])
                                for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {

                                    let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)
                                    var deletedData = await API.graphql({
                                        query: mutations.deleteTimeReportEmployee,
                                        variables: {
                                            input: {
                                                id: timeReportEmployeeData.id,
                                                _version: timeReportEmployeeData._version
                                            }
                                        }
                                    });

                                    if (deletedData) {
                                        // console.log("TimeReportEmployeesDetailsResponse deletedData:-", deletedData);
                                        //delete old employees details
                                        let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])
                                        // console.log("TimeReportEmployeesDetailsResponse:---", TimeReportEmployeesDetailsResponse)


                                        for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
                                            // let timeReportEmployeeDetail = await graphQLFindRecordById("getTimeReportEmployeeDetail", TimeReportEmployeesDetailsResponse[k].id)
                                            // console.log('TimeReportEmployeesDetailsResponse timeReportEmployeeDetail', timeReportEmployeeDetail)
                                            // if (timeReportEmployeeDetail) {
                                            var deletedEmployeeData = await API.graphql({
                                                query: mutations.deleteTimeReportEmployeeDetails,
                                                variables: {
                                                    input: {
                                                        id: TimeReportEmployeesDetailsResponse[k].id,
                                                        _version: TimeReportEmployeesDetailsResponse[k]._version
                                                    }
                                                }
                                            });
                                            // }
                                        }
                                    }
                                }

                                //add new Employees
                                for (var i = 0; i < mappedData.length; i++) {
                                    //Save TimeReportEmployee
                                    var timeReportEmployeeResponse = await API.graphql(
                                        graphqlOperation(mutations.createTimeReportEmployee, {
                                            input: {
                                                employee_Id: mappedData[i].employeeId,
                                                time_Report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                                pay_Rate: String(mappedData[i].employeePayRate),
                                                totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                                            }
                                        })
                                    );
                                    saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse)
                                }
                                //-------------------------------------------
                                toast.success('Data Edited Successfully.');
                                navigateTo("/time_report/" + timeReportInitiatorResponse.id,);
                            }
                        } catch (err) {
                            console.log("Error while approver Edit Form:-", err);
                        }
                    }else{
                    
                    var updateTimeReportInitiateReportData;

                    if(EditByAP==="EditBySA"){
                    updateTimeReportInitiateReportData = await API.graphql({
                        query: mutations.updateTimeReportInitiateReport,
                        variables: {
                            input: {
                                id: timeReportInitiatorResponse.id,
                                _version: timeReportInitiatorResponse._version,
                                school_Department_Id: selectedSchool.code,
                                From_Date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                To_Date: periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                                Type: employeeType,
                                Account: account,
                                pageNo: pageNo,
                                Hourly_Rate: hourlyRate,
                                Daily_Rate: dailyRate,
                                Authorizing_Board_Report_Date: moment(authorizingBoardReportDate).format("YYYY-MM-DD"),
                                Notes: notes,
                                rateType: rateType?.code,

                                First_Approveal: firstApproval.code,
                                validator_id: budgetClerk ? budgetClerk.code : '',
                                Second_Approveal: secondApproval ? secondApproval.code : '',  //budget Manager which is validator
                                // payroll_id: payrollApproval ? payrollApproval.code : '',
                                // Created_By: loggedUserId,
                                // Created_By_Date: moment(currentDateTime).toISOString(),
                            }
                        }
                    });
                    }else{
                    updateTimeReportInitiateReportData = await API.graphql({
                        query: mutations.updateTimeReportInitiateReport,
                        variables: {
                            input: {
                                id: timeReportInitiatorResponse.id,
                                _version: timeReportInitiatorResponse._version,
                                Status: 'RESUBMITTED'
                            }
                        }
                    });
                    }
                    console.log('✌️updateTimeReportInitiateReportData --->', updateTimeReportInitiateReportData);
                    let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id } }])
// console.log('✌️TimeReportEmployeesResponse --->', TimeReportEmployeesResponse);
if(TimeReportEmployeesResponse.length){
    for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {

        let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)

        var deletedData = await API.graphql({
            query: mutations.deleteTimeReportEmployee,
            variables: {
                input: {
                    id: timeReportEmployeeData.id,
                    _version: timeReportEmployeeData._version
                }
            }
        });
        // console.log('✌️deletedData --->', deletedData);
        let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])
// console.log('✌️TimeReportEmployeesDetailsResponse --->', TimeReportEmployeesDetailsResponse);

for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
    // let timeReportEmployeeDetail = await graphQLFindRecordById("getTimeReportEmployeeDetail", TimeReportEmployeesDetailsResponse[k].id)
    // console.log('TimeReportEmployeesDetailsResponse timeReportEmployeeDetail', timeReportEmployeeDetail)
    // if (timeReportEmployeeDetail) {
        var deletedEmployeeData = await API.graphql({
            query: mutations.deleteTimeReportEmployeeDetails,
            variables: {
                input: {
                    id: TimeReportEmployeesDetailsResponse[k].id,
                    _version: TimeReportEmployeesDetailsResponse[k]._version
                }
            }
        });
    // }
}
    }
}

                    for (var i = 0; i < mappedData.length; i++) {
                        //Save TimeReportEmployee
                        var timeReportEmployeeResponse = await API.graphql(
                            graphqlOperation(mutations.createTimeReportEmployee, {
                                input: {
                                    employee_Id: mappedData[i].employeeId,
                                    time_Report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                    pay_Rate: String(mappedData[i].employeePayRate),
                                    totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                                }
                            })
                        );

                        saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse)

                        if (i === mappedData.length - 1) {
                            toast.success('Data Edited Successfully.');
                            // { goBack() }
                        }
                    }
                    let timeReportTransactionCyclesList = await graphQLGetAllData("listTimeReportTransactionCycles")
                    let original = timeReportTransactionCyclesList.filter(e => e.report_Id.includes(reportId))
                    original = original.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
                    var addNewRowForFirstAppResponse = await API.graphql(
                        graphqlOperation(mutations.updateTimeReportTransactionCycle, {
                            input: {
                                id: original[original.length - 1].id,
                                _version:original[original.length - 1]._version,
                                report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                from_Employee_Id: loggedUserId,
                                to_Employee_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.First_Approveal,
                                status: 'Open',
                                // isApproved: false,
                                // remark: '',
                                date: moment().format("YYYY-MM-DD"),
                                customUpdatedAt: moment().format("YYYY-MM-DD HH:mm:ss")
                                // approver_level: ''
                            }
                        })
                    );
                    // var addNewRowForFirstAppResponse = await API.graphql(
                    //     graphqlOperation(mutations.createTimeReportTransactionCycle, {
                    //         input: {
                    //             report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                    //             from_Employee_Id: loggedUserId,
                    //             to_Employee_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.First_Approveal,
                    //             status: 'Open',
                    //             isApproved: false,
                    //             remark: '',
                    //             date: moment().format("YYYY-MM-DD"),
                    //             approver_level: ''
                    //         }
                    //     })
                    // );
                    // console.log('addNewRowForFirstAppResponse', addNewRowForFirstAppResponse)
                    // console.log('addNewRowForFirstAppResponse', addNewRowForFirstAppResponse)
                    // console.log('original :>> ', original);

                 
                    /* await DataStore.save(
                        TimeReportInitiateReport.copyOf(timeReportInitiatorResponse, (updated) => {
                            updated.Status = 'RESUBMITTED';
                        })
                    ).then(async (response) => {

                        //------------------------------------------------------
                        await DataStore.delete(TimeReportEmployee, (c) => c.time_Report_Id.eq(response.id)).then(async (response1) => {
                            await DataStore.delete(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(response1.id)).then(async (response2) => {
                                for (var i = 0; i < mappedData.length; i++) {
                                    //Save TimeReportEmployee
                                    await DataStore.save(
                                        new TimeReportEmployee({
                                            "employee_Id": mappedData[i].employeeId,
                                            "time_Report_Id": response.id,
                                            "pay_Rate": String(mappedData[i].employeePayRate),
                                            "totalEmployeeWorkingHours": String(mappedData[i].employeeTotalHours),
                                        })
                                    ).then(async (timeReportEmployeeResponse) => {
                                        saveEmployeeDetails(timeReportEmployeeResponse.id, mappedData[i].employeeResponse)
                                    })

                                    if (i === mappedData.length - 1) {
                                        toast.success('Data Added Successfully.');
                                        // await handleNotificationsOnStatusChangeforTimeReport('OPEN', response.id, "TIME_REPORT", selectedFirstApprover?.code, loggedUserId);

                                        // { goBack() }
                                    }
                                }
                            })

                        });

                    }) */
                    { goBack() }
                }
                }
                else if (timeReportInitiatorResponse.Status === "PENDING") {
                    let timeReportInitiateReport = await graphQLFindRecordById("getTimeReportInitiateReport", reportId)

                    var deletedTimeReportInitiateReportData = await API.graphql({
                        query: mutations.deleteTimeReportInitiateReport,
                        variables: {
                            input: {
                                id: timeReportInitiateReport.id,
                                _version: timeReportInitiateReport._version
                            }
                        }
                    });

                    let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: deletedTimeReportInitiateReportData.data.deleteTimeReportInitiateReport.id } }])

                    for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {

                        let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)

                        var deletedData = await API.graphql({
                            query: mutations.deleteTimeReportEmployee,
                            variables: {
                                input: {
                                    id: timeReportEmployeeData.id,
                                    _version: timeReportEmployeeData._version
                                }
                            }
                        });

                        let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])

                        for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
                            console.log('TimeReportEmployeesDetailsResponse', TimeReportEmployeesDetailsResponse[k].id)
                            let timeReportEmployeeDetail = await graphQLFindRecordById("getTimeReportEmployeeDetails", TimeReportEmployeesDetailsResponse[k].id)

                            var deletedEmployeeData = await API.graphql({
                                query: mutations.deleteTimeReportEmployeeDetails,
                                variables: {
                                    input: {
                                        id: timeReportEmployeeDetail.id,
                                        _version: timeReportEmployeeDetail._version
                                    }
                                }
                            });

                        }
                    }

                    CommenFunction(status)
                }
                //--------------Added code if sumited form again submit---------------
                else if (timeReportInitiatorResponse.Status === "SUBMITTED") {
                    
                    if(EditByAP==="EditBySA"){
                        
                        try{
                            var updateTimeReportInitiateReportData = await API.graphql({
                                query: mutations.updateTimeReportInitiateReport,
                                variables: {
                                    input: {
                                        id: timeReportInitiatorResponse.id,
                                        _version: timeReportInitiatorResponse._version,
                                        school_Department_Id: selectedSchool.code,
                                        From_Date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                        To_Date: periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                                        Type: employeeType,
                                        Account: account,
                                        pageNo: pageNo,
                                        Hourly_Rate: hourlyRate,
                                        Daily_Rate: dailyRate,
                                        Authorizing_Board_Report_Date: moment(authorizingBoardReportDate).format("YYYY-MM-DD"),
                                        Notes: notes,
                                        rateType: rateType?.code,

                                        First_Approveal: firstApproval.code,
                                        validator_id: budgetClerk ? budgetClerk.code : '',
                                        Second_Approveal: secondApproval ? secondApproval.code : '',  //budget Manager which is validator
                                        // payroll_id: payrollApproval ? payrollApproval.code : '',
                                        // Created_By: loggedUserId,
                                        // Created_By_Date: moment(currentDateTime).toISOString(),
                                    }
                                }
                            });

                            if (updateTimeReportInitiateReportData) {
                                //delete old employees
                                let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id } }])
                                for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {

                                    let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)
                                    var deletedData = await API.graphql({
                                        query: mutations.deleteTimeReportEmployee,
                                        variables: {
                                            input: {
                                                id: timeReportEmployeeData.id,
                                                _version: timeReportEmployeeData._version
                                            }
                                        }
                                    });

                                    if (deletedData) {
                                        //delete old employees details
                                        let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])

                                        for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
                    
                                            var deletedEmployeeData = await API.graphql({
                                                query: mutations.deleteTimeReportEmployeeDetails,
                                                variables: {
                                                    input: {
                                                        id: TimeReportEmployeesDetailsResponse[k].id,
                                                        _version: TimeReportEmployeesDetailsResponse[k]._version
                                                    }
                                                }
                                            });
                                        }
                                    }
                                }

                                //add new Employees
                                for (var i = 0; i < mappedData.length; i++) {
                                    //Save TimeReportEmployee
                                    var timeReportEmployeeResponse = await API.graphql(
                                        graphqlOperation(mutations.createTimeReportEmployee, {
                                            input: {
                                                employee_Id: mappedData[i].employeeId,
                                                time_Report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                                pay_Rate: String(mappedData[i].employeePayRate),
                                                totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                                            }
                                        })
                                    );
                                    saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse);

                                    if (i === mappedData.length - 1) {
                                        let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: reportId } }]);
                                        let transactionCycleResponse = particulerReportAllTransactionCycleRecord.sort((b, a) => (a.createdAt).localeCompare(b.createdAt));
                                        
                                        let updatedMetaData=updateTimeReportInitiateReportData?.data?.updateTimeReportInitiateReport;
                                        //get who is to employee for old data
                                        let initiatorId=timeReportInitiatorResponse.Created_By;
                                        let principalSiteAdmin=timeReportInitiatorResponse?.First_Approveal;
                                        let budgetClerk=timeReportInitiatorResponse?.validator_id;
                                        let budgetManager=timeReportInitiatorResponse?.Second_Approveal;

                                        if (transactionCycleResponse.length > 0) {
                                            let toEmployeeId="";
                                            let toEmpId=transactionCycleResponse[0].to_Employee_Id;

                                            switch(toEmpId){
                                                case principalSiteAdmin:
                                                toEmployeeId=updatedMetaData?.First_Approveal;
                                                break;
            
                                                case budgetClerk:
                                                toEmployeeId=updatedMetaData?.validator_id
                                                ;
                                                break;
            
                                                case budgetManager:
                                                toEmployeeId=updatedMetaData?.Second_Approveal;
                                                break;
            
                                                default:
                                                toEmployeeId=""
                                            }
            
                        
                                            if(toEmployeeId !=""){
            
                                            var timeReportTransactionCycle = await API.graphql(
                                                graphqlOperation(mutations.updateTimeReportTransactionCycle, {
                                                    input: {
                                                        id: transactionCycleResponse[0].id,
                                                        _version: transactionCycleResponse[0]._version,
                                                        to_Employee_Id: toEmployeeId,
                                                        remark: "",
                                                    }
                                                })
                                            );
            
                                            await handleNotificationsOnStatusChangeforTimeReport('OPEN', timeReportInitiatorResponse.id, "TIME_REPORT", toEmployeeId, initiatorId);
                                            
                                            }
                                        }
                                    }
                                }
                                //-------------------------------------------
                                toast.success('Data updated by sa Successfully.');
                                navigateTo("/time_report/SuperAdminDashboard");
                            }

                        }catch(err){
                            console.log("Error when submit super admin is :-",err);
                        }
                    }else{
                    try{
                        var updateTimeReportInitiateReportData = await API.graphql({
                            query: mutations.updateTimeReportInitiateReport,
                            variables: {
                                input: {
                                    id: timeReportInitiatorResponse.id,
                                    _version: timeReportInitiatorResponse._version,
                                    Authorizing_Board_Report_Date:moment(authorizingBoardReportDate).format("YYYY-MM-DD"),
                                    Notes: notes,
                                }
                            }
                        });

                        if(updateTimeReportInitiateReportData){
                        let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id } }])
    
                        for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {
    
                            let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)
    
                            var deletedData = await API.graphql({
                                query: mutations.deleteTimeReportEmployee,
                                variables: {
                                    input: {
                                        id: timeReportEmployeeData.id,
                                        _version: timeReportEmployeeData._version
                                    }
                                }
                            });
                            let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])
                            
                            if(TimeReportEmployeesDetailsResponse){
                             for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
                                        // let timeReportEmployeeDetail = await graphQLFindRecordById("getTimeReportEmployeeDetail", TimeReportEmployeesDetailsResponse[k].id)
                                        // console.log('TimeReportEmployeesDetailsResponse timeReportEmployeeDetail', timeReportEmployeeDetail)
                                        // if (timeReportEmployeeDetail) {
                                            var deletedEmployeeData = await API.graphql({
                                                query: mutations.deleteTimeReportEmployeeDetails,
                                                variables: {
                                                    input: {
                                                        id: TimeReportEmployeesDetailsResponse[k].id,
                                                        _version: TimeReportEmployeesDetailsResponse[k]._version
                                                    }
                                                }
                                            });
                                        // }
                                    }
                        }
                        }
    
                        for (var i = 0; i < mappedData.length; i++) {
                            //Save TimeReportEmployee
                            var timeReportEmployeeResponse = await API.graphql(
                                graphqlOperation(mutations.createTimeReportEmployee, {
                                    input: {
                                        employee_Id: mappedData[i].employeeId,
                                        time_Report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                        pay_Rate: String(mappedData[i].employeePayRate),
                                        totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                                    }
                                })
                            );
    
                            saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse)
                            // var addNewRowForFirstAppResponse = await API.graphql(
                            //     graphqlOperation(mutations.updateTimeReportTransactionCycle, {
                            //         input: {
                            //             report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                            //             from_Employee_Id: loggedUserId,
                            //             to_Employee_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.First_Approveal,
                            //             status: 'Open',
                            //             isApproved: false,
                            //             remark: '',
                            //             date: moment().format("YYYY-MM-DD"),
                            //             approver_level: ''
                            //         }
                            //     })
                            // );
                            if (i === mappedData.length - 1) {
                                toast.success('Data Edited Successfully.');
                                { goBack() }
                            }
                        }
                    }

                    }catch(error){
                        console.log("Error when Submitted form submit",error);
                    };
                }
                }
                //-----------------------------

                else if (EditByAP == "EditByAP") {
                    try {
                        // Update record
                        var updateTimeReportInitiateReportData = await API.graphql({
                            query: mutations.updateTimeReportInitiateReport,
                            variables: {
                                input: {
                                    id: timeReportInitiatorResponse.id,
                                    _version: timeReportInitiatorResponse._version,
                                    // Status: 'RESUBMITTED'

                                    school_Department_Id: selectedSchool.code,
                                    From_Date: moment(periodDates[0]).format("YYYY-MM-DD"),
                                    To_Date: periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                                    Type: employeeType,
                                    Account: account,
                                    pageNo: pageNo,
                                    Hourly_Rate: hourlyRate,
                                    Daily_Rate: dailyRate,
                                    Authorizing_Board_Report_Date: moment(authorizingBoardReportDate).format("YYYY-MM-DD"),
                                    Notes: notes,
                                    rateType: rateType?.code,

                                    // First_Approveal: firstApproval.code,
                                    // validator_id: budgetClerk ? budgetClerk.code : '',
                                    // Second_Approveal: secondApproval ? secondApproval.code : '',  //budget Manager which is validator
                                    // payroll_id: payrollApproval ? payrollApproval.code : '',
                                    // Created_By: loggedUserId,
                                    // Created_By_Date: moment(currentDateTime).toISOString(),
                                }
                            }
                        });


                        //-------------------------------------------
                        if (updateTimeReportInitiateReportData) {
                            //delete old employees
                            let TimeReportEmployeesResponse = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id } }])
                            for (let j = 0; j < TimeReportEmployeesResponse.length; j++) {

                                let timeReportEmployeeData = await graphQLFindRecordById("getTimeReportEmployee", TimeReportEmployeesResponse[j].id)
                                var deletedData = await API.graphql({
                                    query: mutations.deleteTimeReportEmployee,
                                    variables: {
                                        input: {
                                            id: timeReportEmployeeData.id,
                                            _version: timeReportEmployeeData._version
                                        }
                                    }
                                });

                                if(deletedData){
                                    console.log("TimeReportEmployeesDetailsResponse deletedData:-",deletedData);
                                    //delete old employees details
                                    let TimeReportEmployeesDetailsResponse = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: deletedData.data.deleteTimeReportEmployee.id } }])
                                    console.log("TimeReportEmployeesDetailsResponse:---",TimeReportEmployeesDetailsResponse)
                                
                                
                                    for (let k = 0; k < TimeReportEmployeesDetailsResponse.length; k++) {
                                        // let timeReportEmployeeDetail = await graphQLFindRecordById("getTimeReportEmployeeDetail", TimeReportEmployeesDetailsResponse[k].id)
                                        // console.log('TimeReportEmployeesDetailsResponse timeReportEmployeeDetail', timeReportEmployeeDetail)
                                        // if (timeReportEmployeeDetail) {
                                            var deletedEmployeeData = await API.graphql({
                                                query: mutations.deleteTimeReportEmployeeDetails,
                                                variables: {
                                                    input: {
                                                        id: TimeReportEmployeesDetailsResponse[k].id,
                                                        _version: TimeReportEmployeesDetailsResponse[k]._version
                                                    }
                                                }
                                            });
                                        // }
                                    }
                                }
                            }

                            //add new Employees
                            for (var i = 0; i < mappedData.length; i++) {
                                //Save TimeReportEmployee
                                var timeReportEmployeeResponse = await API.graphql(
                                    graphqlOperation(mutations.createTimeReportEmployee, {
                                        input: {
                                            employee_Id: mappedData[i].employeeId,
                                            time_Report_Id: updateTimeReportInitiateReportData.data.updateTimeReportInitiateReport.id,
                                            pay_Rate: String(mappedData[i].employeePayRate),
                                            totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                                        }
                                    })
                                );
                                saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse)
                            }
                            //-------------------------------------------
                            toast.success('Data Added Successfully.');
                            navigateTo("/time_report/"+timeReportInitiatorResponse.id);
                        }
                    } catch (err) {
                        console.log("Error while approver Edit Form:-", err);
                    }
                }

            } catch (err) {
                console.log("Error on saveReport Function ", err);
            }
            //------------------------------------------------------------------------------

            /*  await DataStore.delete(TimeReportInitiateReport, (c) => c.id.eq(reportId)).then(async (response) => {
                 await DataStore.delete(TimeReportEmployee, (c) => c.time_Report_Id.eq(response.id)).then(async (response) => {
                     await DataStore.delete(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(response.id)).then(async (response) => {
                         CommenFunction(status)
                     })
                 })
             }) */
            }
        } else {
            CommenFunction(status)
        }
    }

    const CommenFunction = async (status) => {
        console.log('status', status)

        try {
            // save ALL data to datastore

            var createTimeReportInitiateReportData = await API.graphql(
                graphqlOperation(mutations.createTimeReportInitiateReport, {
                    input: {
                        school_Department_Id: selectedSchool.code,
                        From_Date: moment(periodDates[0]).format("YYYY-MM-DD"),
                        To_Date: periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                        Type: employeeType,
                        Account: account,
                        pageNo: pageNo,
                        Hourly_Rate: hourlyRate,
                        Daily_Rate: dailyRate,
                        Authorizing_Board_Report_Date: moment(authorizingBoardReportDate).format("YYYY-MM-DD"),

                        First_Approveal: firstApproval.code,
                        validator_id: budgetClerk ? budgetClerk.code : '',
                        Second_Approveal: secondApproval ? secondApproval.code : '',  //budget Manager which is validator
                        payroll_id: payrollApproval ? payrollApproval.code : '',

                        Status: status,
                        Notes: notes,
                        Created_By: loggedUserId,
                        Created_By_Date: moment(currentDateTime).toISOString(),
                        rateType: rateType?.code
                    }
                })
            );
            console.log('createTimeReportInitiateReportData', createTimeReportInitiateReportData.data.createTimeReportInitiateReport.First_Approveal)

            for (var i = 0; i < mappedData.length; i++) {
                //Save TimeReportEmployee
                var timeReportEmployeeResponse = await API.graphql(
                    graphqlOperation(mutations.createTimeReportEmployee, {
                        input: {
                            employee_Id: mappedData[i].employeeId,
                            time_Report_Id: createTimeReportInitiateReportData.data.createTimeReportInitiateReport.id,
                            pay_Rate: mappedData[i].employeePayRate ? String(mappedData[i].employeePayRate) : '',
                            totalEmployeeWorkingHours: String(mappedData[i].employeeTotalHours)
                        }
                    })
                );

                if (timeReportEmployeeResponse.data.createTimeReportEmployee.id) {
                    saveEmployeeDetails(timeReportEmployeeResponse.data.createTimeReportEmployee.id, mappedData[i].employeeResponse)
                }
            }

            if (Request_Status.P === status) {
                navigateTo("/timereport/initiatenewreport/" + createTimeReportInitiateReportData.data.createTimeReportInitiateReport.id);
            }

            if(EditByAP==="copyReport"){
                toast.success('The form has been cloned.');
            }else{
            toast.success('Data Added Successfully.');
            }

            if (Request_Status.S === status) {
                //after submit add entry on transaction table data

                var addNewRowForFirstAppResponse = await API.graphql(
                    graphqlOperation(mutations.createTimeReportTransactionCycle, {
                        input: {
                            report_Id: createTimeReportInitiateReportData.data.createTimeReportInitiateReport.id,
                            from_Employee_Id: loggedUserId,
                            to_Employee_Id: createTimeReportInitiateReportData.data.createTimeReportInitiateReport.First_Approveal,
                            status: 'Open',
                            isApproved: false,
                            remark: '',
                            date: moment().format("YYYY-MM-DD"),
                            approver_level: ''
                        }
                    })
                );
                console.log('addNewRowForFirstAppResponse', addNewRowForFirstAppResponse)

                //console.log(addNewRowForFirstAppResponse)

                //time report after intiating newreport notification code start
                if (addNewRowForFirstAppResponse) {
                    await handleNotificationsOnStatusChangeforTimeReport('OPEN', createTimeReportInitiateReportData.data.createTimeReportInitiateReport.id, "TIME_REPORT", createTimeReportInitiateReportData.data.createTimeReportInitiateReport.First_Approveal, loggedUserId);
                }
                {
                    goBack()
                    // navigateTo("/timereport/initiatenewreport/" + createTimeReportInitiateReportData.data.createTimeReportInitiateReport.id);
                }
            }


            //navigateTo("/timereport/initiatenewreport/" + response.id);

            // if(Request_Status.P === status){
            // navigateTo("/timereport/initiatenewreport/" + response.id);
            // navigateTo(0);
            // }else{
            // { goBack() }
            // }
            //{ goBack() }

            /* await DataStore.save(
                new TimeReportInitiateReport({
                    "school_Department_Id": selectedSchool.code,
                    "From_Date": moment(periodDates[0]).format("YYYY-MM-DD"),
                    "To_Date": periodDates[1] ? moment(periodDates[1]).format("YYYY-MM-DD") : moment(periodDates[0]).add(15, 'days').format("YYYY-MM-DD"),
                    "Type": employeeType,
                    "Account": account,
                    "pageNo": pageNo,
                    "Hourly_Rate": hourlyRate,
                    "Daily_Rate": dailyRate,
                    "Authorizing_Board_Report_Date": moment(authorizingBoardReportDate).format("YYYY-MM-DD"),
                    "First_Approveal": firstApproval.code,
                    "Second_Approveal": secondApproval ? secondApproval.code : '',
                    "payroll_id": payrollApproval ? payrollApproval.code : '',
                    "validator_id": validator ? validator.code : '',
                    "Status": status,
                    "Notes": notes,
                    "Created_By": loggedUserId,
                    "Created_By_Date": moment(currentDateTime).toISOString()
                })
            ).then(async (response) => {
                //console.log("response",response)
                for (var i = 0; i < mappedData.length; i++) {
                    //Save TimeReportEmployee
                    await DataStore.save(
                        new TimeReportEmployee({
                            "employee_Id": mappedData[i].employeeId,
                            "time_Report_Id": response.id,
                            "pay_Rate": mappedData[i].employeePayRate ? String(mappedData[i].employeePayRate) : '',
                            "totalEmployeeWorkingHours": String(mappedData[i].employeeTotalHours),
                        })
                    ).then(async (timeReportEmployeeResponse) => {
                        console.log("response", timeReportEmployeeResponse)

                        saveEmployeeDetails(timeReportEmployeeResponse.id, mappedData[i].employeeResponse)
                    })

                    if (i === mappedData.length - 1) {
                        toast.success('Data Added Successfully.');

                        if (Request_Status.S === status) {
                            //after submit add entry on transaction table data
                            const addNewRowForFirstAppResponse = await DataStore.save(new TimeReportTransactionCycle({
                                "report_Id": response.id,
                                "from_Employee_Id": loggedUserId,
                                "to_Employee_Id": response.First_Approveal,
                                "status": 'Open',
                                "isApproved": false,
                                "remark": '',
                                "date": moment().format("YYYY-MM-DD"),
                                "approver_level": '',
                            }));


                            //console.log(addNewRowForFirstAppResponse)

                            //time report after intiating newreport notification code start
                            if (addNewRowForFirstAppResponse) {
                                await handleNotificationsOnStatusChangeforTimeReport('OPEN', response.id, "TIME_REPORT", response.First_Approveal, loggedUserId);
                            }
                        }


                        if (Request_Status.P === status) {
                            //
                        }
                        //navigateTo("/timereport/initiatenewreport/" + response.id);
                        { goBack() }

                        // if(Request_Status.P === status){
                        // navigateTo("/timereport/initiatenewreport/" + response.id);
                        // navigateTo(0);
                        // }else{
                        // { goBack() }
                        // }
                        //{ goBack() }

                    }
                }

            }) */

        } catch (e) { console.log("Error in Common Function", e) }
    }

    //*Save Employee Details
    const saveEmployeeDetails = async (timeReportEmployeeId, employeeDetailsData) => {

        if (employeeDetailsData.length > 0) {
            for (let i = 0; i < employeeDetailsData.length; i++) {

                // Create record
                await API.graphql(
                    graphqlOperation(mutations.createTimeReportEmployeeDetails, {
                        input: {
                            time_Report_Employee_Id: timeReportEmployeeId,
                            date: moment(employeeDetailsData[i].selectedDate).format("YYYY-MM-DD"),
                            totalHours: String(employeeDetailsData[i].totalHour),
                            totalMin: String(employeeDetailsData[i].minutes),
                            totalHoursAndMinDisplay: String(employeeDetailsData[i].totalHourAndMinutesDisplay)
                        }
                    })
                );
                /* await DataStore.save(
                    new TimeReportEmployeeDetails({
                        "time_Report_Employee_Id": timeReportEmployeeId,
                        "date": moment(employeeDetailsData[i].selectedDate).format("YYYY-MM-DD"),
                        "totalHours": String(employeeDetailsData[i].totalHour),
                        "totalMin": String(employeeDetailsData[i].minutes),
                        "totalHoursAndMinDisplay": String(employeeDetailsData[i].totalHourAndMinutesDisplay)
                    })
                ); */
            }
        }
    }

    const CalendarValidation = () => {
        if(!selectedEmployee)
        toast.error("Please select Employee.")
    }

    //*onclick Edit;
    const onClickEdit = (data) => {
        setAbsentDate([]);
        setIsEditDates(true);
        setIsShowSelectedDate(true)
        setSelectedEmployee({ name: data.employeeName, code: data.employeeId });
        // setEmployeeList([{ name: data.employeeName, code: data.employeeId }])
        setPayRate(data.employeePayRate);
        setIsEditDateIndex(data.employeeIndex);
        let employeeResponse = data.employeeResponse;
        console.log("employeeResponse:-",data);
        let newResponse = [];
        for (let i = 0; i < employeeResponse.length; i++) {
            let data = { "employeeName": employeeResponse[i].employeeName, "selectedDate": employeeResponse[i].selectedDate, "displayDate": employeeResponse[i].displayDate, "totalHour": employeeResponse[i].totalHour, "minutes": employeeResponse[i].minutes, "totalHourAndMinutesDisplay": employeeResponse[i].totalHourAndMinutesDisplay,isWrong:employeeResponse[i].isWrong }
            newResponse.push(data)
            if (i === employeeResponse.length - 1) {
                setSelectedDateRecord(newResponse)
            }
        }
    }

    const editTotalHour = (row, hours) => {

    }
    const initiatorEditPopUpAction = (row) => {
        return (
            <div className="flex justify-center w-full grid grid-cols-3 gap-4" >
                <Link to='#' className="py-2 px-2.5"
                    onClick={() => {
                        onClickEdit(row);
                    }}
                >
                    <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>

                <Link to='#' className="pi pi-trash py-2 px-2.5 text-[18px] text-[#667085] font-meduim"
                    onClick={() => {
                        onClickRemove(row);
                    }}
                >
                    {/* <i className="pi-trash text-[18px] text-[#667085] font-meduim"></i> */}
                </Link>

                {row.isCommonWrong?<i className="pi pi-ban pt-2" style={{ color: 'red' }}></i>:<></>}

            </div>
        );
    };

    // const onSetEmployee = (e) => {
    //     console.log("e.value.code", e.value.code)
    //      if (e && e.value) {
    //     setSelectedEmployee(e.value);
    //     //setEmployeeList([e.value])
    //     setDateCount(0);
    //     setEmpDisable(true)
    //     setIsAuthorizingBRDate(true)
    //     //create new list without selected employee
    //     let newEmpList = [];
    //     employeeList?.map((currentItem) => {
    //         console.log("currentItem123",currentItem.code)
    //         if (currentItem && currentItem?.code !== e.value?.code) {
    //             newEmpList.push(currentItem);
    //         }
    //     })
    //     setUpdatedEmpList(newEmpList);
    //     //set first and second Approval list
    //     // const updatedFirstApproval = approvalOneList.filter(item => item.code !== e.value.code); setApprovalOneList(updatedFirstApproval);
    //     // const updatedSecondApproval = approvalSecondList.filter(item => item.code !== e.value.code); setApprovalSecondList(updatedSecondApproval);
    //     }
    // }
    const onSetEmployee = (e) => {
        if (e && e.value) {
            // Employee is selected
            setSelectedEmployee(e.value);
            setDateCount(0);
            setEmpDisable(false);
            setIsAuthorizingBRDate(true);
            // Create a new list without the selected employee
            let newEmpList = employeeList.filter((currentItem) => currentItem.code !== e.value.code);
            setUpdatedEmpList(newEmpList);
            // Rest of your code...
        } else {
            // Clear action or undefined value
            setSelectedEmployee(e.value); // Set to null or any default value as needed
            setDateCount(0);
            setEmpDisable(false);
            setIsAuthorizingBRDate(true);
            setUpdatedEmpList([]); // Update the list accordingly
        }
    };

    const OnChangeEdit = (e) => {
        //mapped Data
        if (mappedData && mappedData.length) {
            console.log(mappedData, "mappedData")
            let row = mappedData.filter(item => item.employeeId === e.value?.code)
            console.log(row, "row")
            if (row.length) {
                onClickEdit(row[0])
            }
        }
    }

    //* onClick First Approval
    const onClickFirstApproval = (e) => {
        console.log(firstApproval)
        // const updatedSecondApproval = approvalSecondList.filter(item => item.code !== e.code); setApprovalSecondList(updatedSecondApproval);
    }

    useEffect(() => {
        let timeReportIsSuperadmin = reactLocalStorage.get("timeRIsSAdmin"); 
        setTimeReportIsSuperadmin(timeReportIsSuperadmin);
        onLoad();
        BindList();
    }, []);


    useEffect(() => {
        console.log('isMasterDataLoaded', isMasterDataLoaded)

        if (isMasterDataLoaded === true) {
            if (reportId) {
                getData()
            }
            loadUsers();
            setVisibleDialogue(false)
        }
    }, [isMasterDataLoaded]);

    const Alertopen =async ()=>{
        var getTimeReportInitiate =await graphQLFindRecordById("getTimeReportInitiateReport", reportId)
                if(getTimeReportInitiate?.school_Department_Id&&reportId&&selectedSchool?.code&&getTimeReportInitiate.school_Department_Id!==selectedSchool?.code&&mappedData.length){
                    // setAlertForChangeSchool(true)
                   let isConfirm= window.confirm(" All data in the preview section will be deleted. Confirm your choice below")
                   console.log('isConfirm :>> ', isConfirm);
                   if(isConfirm){
                    onClickDataClear()
                   }else{
                    var getTimeReportOfEmployee = allSchoolList.find(o => o.id === getTimeReportInitiate.school_Department_Id)
                   setSelectedSchool( { name: getTimeReportOfEmployee.name, code: getTimeReportOfEmployee.id }) 
                   }
                }
    }
    useEffect(() => {
        Alertopen()
    }, [selectedSchool])
    
const onClickDataClear= ()=>{
    setMappedData([])
}

    return isAuthenticated ? (
        <>
            <Layout pageTitle="Homepage" activeMenu={(EditByAP == "EditBySA") ? "SuperAdmin" : "Initiator"} appId={'TIME_REPORT'} IsSuperadmin={timeReportIsSuperadmin}
            reDirectUrl={"/time_report"}
            reDirectUrlforSA={"/time_report/SuperAdminDashboard"}>
                <div className="">
                    <div className="pt-24 md:pt-28 xl:pt-[2.083vw]">
                        <div className="">

                            <div className="text-[#113699] font-semibold -tracking-[0.02em] text-xl xl:text-[1.042vw]">
                                <h3>Initiate New Report</h3>
                            </div>
                            <div className="mt-5 xl:mt-[1.250vw]">
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[0.833vw] cust-select">

                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of School or Department <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={selectedSchool}
                                                onChange={(e) => {
                                                    if(EditByAP==="copyReport"){
                                                        let isConfirm=window.confirm("Alert All data in the preview section will be deleted. Confirm your choice below.");
                                                            if(isConfirm){
                                                                // setTeachers([{ teacherName: '', datesNeeded: [], indicateIf: '', gradeOrSubject: '', note: '' }]);
                                                                setMappedData([]);
                                                                EmployeeList(e)
                                                                setDateCount(0);
                                                            }else{
                                                                return 0;
                                                            }
                                                    }else{
                                                    EmployeeList(e)
                                                    setDateCount(0);
                                                    }
                                                }}
                                                filter
                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                // disabled={isEmpDisable }
                                                options={schoolList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
                                    </div>


                                    <div className="w-full ">
                                        <div className="">
                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Period <span className='text-[red] pl-0.2'>*</span></label> </div>
                                        <div className="w-full">
                                            <div className="relative custp-calender">
                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                                <div className="card justify-content-center">
                                                    {
                                                        reportId && EditByAP==="copyReport"?
                                                        <Calendar
                                                            onChange={(e) => {
                                                                if (e.value && e.value.length > 0) {
                                                                    setPeriodDates(null);
                                                                    setPeriodDates(e.value);
                                                                }
                                                            }}
                                                            value={periodDates}
                                                            minDate={minDate}
                                                            maxDate={maxDate}
                                                            // disabled={disabled}
                                                            disabled={isEmpDisable}
                                                            placeholder="Date Range"
                                                            selectionMode="range"
                                                            className="w-full h-11" />
                                                            :
                                                    // }
                                                    // {
                                                    reportId ?
                                                        <div onClick={() => CalendarValidation()}>
                                                            <Calendar
                                                              onChange={(e) => {
                                                                if (e.value && e.value.length > 0) {
                                                                    setPeriodDates(null);
                                                                    setPeriodDates(e.value);
                                                                }
                                                            }}
                                                            minDate={minDate}
                                                            maxDate={maxDate}
                                                                // disabled={isEmpDisable}
                                                                value={periodDates}
                                                                placeholder="Date Range"
                                                                selectionMode="range"
                                                                className="w-full h-11" />

                                                        </div>
                                                        :
                                                        <Calendar
                                                            onChange={(e) => {
                                                                // setPeriodDates(null);
                                                                //console.log(e.value[1].getDate() === e.value[0])
                                                                //if(e.value.length > 1 && e.value[1] === null   ){ toast.error("change "); return }
                                                                // setPeriodDates(e.value)
                                                                // const nextMinDate = new Date(e.value);
                                                                // const nextMaxDate = new Date(e.value);
                                                                // nextMaxDate.setDate(nextMinDate.getDate() + 60);
                                                                // setMinDate(nextMinDate);
                                                                // setMaxDate(nextMaxDate);
                                                                if (e.value && e.value.length > 0) {
                                                                    setPeriodDates(null);

                                                                    setPeriodDates(e.value);
                                                                    // Additional operations...
                                                                }
                                                            }}
                                                            value={periodDates}
                                                            minDate={minDate}
                                                            maxDate={maxDate}
                                                            // disabled={disabled}
                                                            // disabled={isEmpDisable}
                                                            placeholder="Date Range"
                                                            selectionMode="range"
                                                            className="w-full h-11" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Type <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="employee"
                                                value={employeeTypeShow}
                                                // disabled={isEmpDisable}
                                                onChange={(e) => {
                                                    setEmployeeTypeShow(e.target.value);
                                                    if (e.target.value.name === "Certificated") { setEmployeeType(EmployeeTypeEnum.CERTIFICATED) }
                                                    else if (e.target.value.name === "Classified") { setEmployeeType(EmployeeTypeEnum.CLASSIFIED) }
                                                }} options={employeeTypeList}
                                                filter
                                                optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>


                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Account # <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <InputText id="employee"
                                                value={account}
                                                // disabled={isEmpDisable}
                                                onChange={(e) => { setAccount(e.target.value); }}
                                                placeholder="Account" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[0.833vw] cust-select mt-2">

                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Rate Type <span className='text-[red] pl-0.2'>*</span> </label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={rateType}
                                                onChange={(e) => {
                                                    if (e.target.value.code === 1) {
                                                        setIsHourlyRate(false);
                                                        setDailyRate("");
                                                    } else { setIsHourlyRate(true); setHourlyRate(""); }
                                                    setRateType(e.target.value)
                                                }}
                                                filter
                                                // disabled={disabled}
                                                // disabled={isEmpDisable}
                                                options={rateTypeList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
                                    </div>

                                    {
                                        isHourlyRate === false ?
                                            <div className="w-full">
                                                <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Daily Rate  <span className='text-[red] pl-0.2'>*</span></label>
                                                <div className="relative">
                                                    <InputText id="employee"
                                                        value={dailyRate}
                                                        // disabled={isEmpDisable}
                                                        onChange={(e) => { setDailyRate(e.target.value); }}
                                                        placeholder="Daily Rate" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                                </div>
                                            </div> :
                                            <div className="w-full">
                                                <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Hourly Rate </label>
                                                <div className="relative">
                                                    <InputText id="employee"
                                                        value={hourlyRate}
                                                        // disabled={isEmpDisable}
                                                        onChange={(e) => { setHourlyRate(e.target.value) }}
                                                        placeholder="Hourly Rate" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                                </div>
                                            </div>
                                    }



                                    <div className="w-full">
                                        <div className="">
                                            <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Authorizing Board Report Date <span className='text-[red] pl-0.2'>*</span></label> </div>
                                        <div className="w-full">
                                            <div className="relative custp-calender">
                                                <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                                <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                                <div className="card justify-content-center">
                                                    <Calendar
                                                        onChange={(e) => {
                                                            setAuthorizingBoardReportDate(e.value)
                                                        }}
                                                        value={authorizingBoardReportDate}
                                                        //disabled={isAuthorizingBRDate? false : true}
                                                        placeholder="Authorizing Board Report Date"
                                                        className="w-full h-11" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Page No # <span className='text-[red] pl-0.2'>*</span> </label>
                                        <div className="relative">
                                            <InputText id="employee"
                                                value={pageNo}
                                                // disabled={isEmpDisable}
                                                onChange={(e) => { setPageNo(e.target.value); }}
                                                placeholder="Page No." className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[0.833vw] cust-select mt-2">


                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Principal/ Dept Head <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={firstApproval}
                                                onChange={(e) => {
                                                    setFirstApproval(e.target.value)
                                                    onClickFirstApproval(e.target.value)
                                                }}
                                                filter
                                                // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                // disabled={(disablefirstApproval) ? true : false}
                                                disabled={disablePrinciple}

                                                options={allApproverList}
                                                onKeyDown={e => {
                                                    UserList(e)
                                                }}

                                                optionLabel="name"
                                                placeholder="Select"
                                                className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5"
                                                style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
                                    </div>


                                    {/******budget clerk******/}
                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Clerk</label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={budgetClerk}
                                                onChange={(e) => {
                                                    // setValidator(e.target.value)
                                                    setBudgetClerk(e.target.value)
                                                }}
                                                filter
                                                onKeyDown={e => {
                                                    setUserListByClerk(e)
                                                }}
                                                // options={allApproverList}
                                                options={budgetClerkList}
                                                optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                // disabled={(EditByAP == "EditByAP"||EditByAP=="EditBySA"&&disableSecondApproval) ? true : false}
                                                disabled={disableBudgetClerk}
                                            />
                                        </div>
                                    </div>


                                    <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Budget Manager  {budgetClerk ? <span className='text-[red] pl-0.2'>*</span> : null}   </label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            {
                                                (EditByAP == "EditByAP"||EditByAP=="EditBySA") ?
                                                    <Dropdown id="dept"
                                                        value={secondApproval}
                                                        options={allApproverList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}

                                                        onChange={(e) => {
                                                            setSecondApproval(e.target.value)
                                                        }}
                                                        filter
                                                        onKeyDown={e => {
                                                            UserList(e)
                                                        }}
                                                        // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                        // disabled={(EditByAP == "EditByAP"||EditByAP=="EditBySA"&&disableThirdApproval) ? true : false}
                                                        disabled={disableBudgetManager}
                                                    /> :

                                                    <Dropdown id="dept" value={secondApproval}
                                                        onChange={(e) => {
                                                            setSecondApproval(e.target.value)
                                                        }}
                                                        filter
                                                        onKeyDown={e => {
                                                            UserList(e)
                                                        }}
                                                        // disabled={isEmpDisable ? isEmpDisable : disabled}
                                                        // disabled={(budgetClerk && !isEmpDisable) ? false : true}
                                                        // disabled={(EditByAP == "EditByAP"||EditByAP=="EditBySA"&&disableThirdApproval) ? true : false}
                                                        disabled={disableBudgetManager?true:(budgetClerk)?false:true}
                                                        options={allApproverList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                                    />
                                            }
                                        </div>
                                    </div>

                                    {/****payroll***/}
                                    {/*  <div className="w-full">
                                        <label htmlFor="dept" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Payroll <span className='text-[red] pl-0.2'>*</span> </label>
                                        <div className="relative">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="dept" value={payrollApproval}
                                                onChange={(e) => {
                                                    setPayrollApproval(e.target.value)
                                                }}
                                                filter
                                               
                                                disabled={isEmpDisable ? true : true}
                                                options={payrollList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                        </div>
</div>  */}

                                    {/****Notes***/}

                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Notes</label>
                                        <div className="relative">
                                            <InputText id="employee"
                                                value={notes}
                                                onChange={(e) => { setNotes(e.target.value); }}
                                                placeholder="Enter Your Notes." className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
                                    </div>




                                    {/* {!isValidator ?
                                        <div className="w-full"> </div> : null
                                    } */}

                                    <div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Name of the Employee <span className='text-[red] pl-0.2'>*</span></label>
                                        <div className="relative flex">
                                            <i className="gusd-employee text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                            <Dropdown id="employee"
                                                value={selectedEmployee}
                                                onChange={(e) => { onSetEmployee(e); setSelectedDateRecord([]); OnChangeEdit(e); setAbsentDate([]) }} options={employeeList}
                                                filter
                                                showClear
                                                // onKeyDown={e => {
                                                //     setEmpList(e, "employee")
                                                // }}
                                                optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                            <div onClick={(e) => setOpenNewEmployee(true)} className='cursor-pointer text-[30px] '>
                                                {/* <i className='gusd-pluse-circle' style = {{color: "lightgray",fontSize: "20px", margin: "3px",position:"relative", bottom:"6px"}}></i> */}
                                                <Tooltip target=".icon-tooltip" content="Add Employee" position="top" className="custom-tooltip-content" />
                                                <i className='icon-tooltip gusd-pluse-circle' style={{ color: "lightgray", fontSize: "20px", margin: "3px", position: "relative", bottom: "6px" }}></i>
                                            </div>

                                        </div>
                                    </div>
                                    {/* Add New Employee Popup */}
                                    <Dialog
                                        header="Add New Employee" draggable={false} className='add_New_Employee'
                                        visible={openNewEmployee}
                                        style={{ width: "30vw" }}

                                        onHide={() => {
                                            setOpenNewEmployee(false);

                                        }}
                                    // footer={footerContentForReqReject}
                                    >
                                        <div className="m-0">

                                            <div className="font-medium text-sm mb-2 mt-3">School/Department <span className="text-[red] pl-0.2">*</span></div>
                                            <Dropdown id="dept" value={selectedSchool}
                                                onChange={(e) => { EmployeeList(e); setNewEmployeeSchool(e.value) }}
                                                filter
                                                disabled={disabled}
                                                options={schoolList} optionLabel="name" placeholder="Select School/Department" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                            />
                                            {/* <div className="font-medium text-[18px] mb-2 mt-3">Employee Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeName}
                                                placeholder=""
                                                onChange={e => { setNewEmployeeName(e.target.value) }}
                                                className="w-full"
                                            /> */}
                                            <div className="font-medium text-sm mb-2 mt-3">First Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={newEmpFirstName}
                                                placeholder="Enter First Name"
                                                onChange={e => { setNewEmpFirstName(e.target.value) }}
                                                className="w-full"
                                            />
                                            <div className="font-medium text-sm mb-2 mt-3">Last Name <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={newEmpLastName}
                                                placeholder="Enter Last Name"
                                                onChange={e => { setNewEmpLastName(e.target.value) }}
                                                className="w-full"
                                            />
                                            {/* <div className="font-medium text-[18px] mb-2 mt-3">Select Role 
                                            <span className="text-[red] pl-0.2">*</span>
                                            </div>
                                            <Dropdown value={newEmpSelectedRole} onChange={(e) => setNewEmpSelectedRole(e.value)} options={rolesArray} optionLabel="name"
                                                placeholder="Select a Role" className="w-full md:w-14rem" />

                                            <div className="font-medium text-[18px] mb-2 mt-3">Designation<span className="text-[red] pl-0.2 pl-0.2">*</span></div>
                                            <Dropdown value={newEmpSelectedDesignation} onChange={(e) => setNewEmpSelectedDesignation(e.value)} options={designationForAllApps} optionLabel="name"
                                                placeholder="Select a Designation" className="w-full md:w-14rem" /> */}
                                            {/* -------------------------------- */}



                                            <div className="font-medium text-sm mb-2 mt-3">Employee Code <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeCode}
                                                placeholder="Select Employee Code"
                                                onChange={e => { setNewEmployeeCode(e.target.value) }}
                                                className="w-full"
                                            />

                                            <div className="font-medium text-sm mb-2 mt-3 ">Employee Email Address <span className="text-[red] pl-0.2">*</span></div>
                                            <InputText
                                                value={NewEmployeeEmail}
                                                placeholder="Enter Employee Email Address"
                                                onChange={e => { setNewEmployeeEmail(e.target.value) }}
                                                className="w-full"
                                            />
                                        </div>
                                        <div className='flex justify-between gap-2 mt-3'>
                                            <Link to="" onClick={() => { setOpenNewEmployee(false); }}
                                                className='text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                <i class="pi pi-times"></i><span>Cancel</span></Link>

                                            <Link to="" onClick={() => { AddNewEmployee() }}
                                                className='text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer'>
                                                <i class="pi pi-check"></i><span>Add</span></Link>

                                        </div>
                                    </Dialog>



                                    {/*<div className="w-full">
                                        <label htmlFor="employee" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Pay Rate </label>
                                        <div className="relative">
                                            <InputText id="employee"
                                                value={payRate}
                                                onChange={(e) => { setPayRate(e.target.value); }}
                                                placeholder="Pay Rate" className="w-full h-11 rounded-md border border-[#E4E7EC] pl-5" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }} />
                                        </div>
</div> */}

                                </div>
                            </div>

                            <div className="mt-5 xl:mt-[1.094vw] pb-10 ">
                                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 xl:gap-[1.250vw]">
                                    <div className="col-span-12 lg:col-span-8">
                                        <div id={SelectperiodExpand} className="box-shadow-1 bg-white">
                                            <div className="flex justify-between items-center p-4 xl:p-[0.833vw]">
                                                <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]"><p>Select Period</p></div>
                                                <div className=""><Button href={'/'} onClick={toggleActiveexpand} style={{ background: '#ffffff00', border: '0', padding: '0', width: '24px', height: '24px' }}><i className="gusd-expand text-base text-[#101828]"></i></Button></div>
                                            </div>
                                            <div className="custmCalendar p-4 xl:p-[0.833vw]">
                                                <Calendar
                                                    value={absentDate}
                                                    onChange={(e) => {
                                                        if (reportId) {
                                                            if (!selectedEmployee) { toast.error("Please Select Employee"); return; } else {
                                                                onClickDates(e.value);
                                                                setAbsentDate(e.value);
                                                            }
                                                        } else {
                                                            onClickDates(e.value);
                                                            setAbsentDate(e.value);
                                                        }
                                                    }}
                                                    minDate={new Date(moment(periodDates[0]).format("YYYY,M,DD"))}
                                                    maxDate={new Date(moment(periodDates[1]).format("YYYY,M,DD"))}
                                                    inline
                                                    disabledDates={disabledDates}
                                                    selectionMode="multiple" />
                                            </div>
                                        </div>

                                        <div className="mt-6 xl:mt-[1.250vw]">
                                            <div className="bg-white box-shadow-1">
                                                <div className="p-4 xl:p-[0.833vw] pb-0">
                                                    <div className="text-[#101828] font-semibold -tracking-[0.02em] text-base xl:text-[0.833vw]">
                                                        <p>Preview</p></div></div>
                                                <div className="px-3 xl:px-[0.677vw] custp-table-d initiatorperiodtable">
                                                    {

                                                        visible === true ?
                                                            <DataTable
                                                                className="custpaginator custIcons custmBtnTable custTable"
                                                                scrollable
                                                                value={mappedData}
                                                                paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                                                                // dataKey="srNo" filters={filters} globalFilterFields={['assignmentTitle', 'submittedOn', 'status', 'remark']}
                                                                // header={header}
                                                                emptyMessage="No record found."
                                                            >
                                                                <Column field="employeeName" header="Name of Employee" style={{ minWidth: '3rem' }}></Column>

                                                                <Column field="employeeTotalHours" header="Total Hours" sortable style={{ minWidth: '5rem' }}></Column>
                                                                <Column field="action" header="Action" align='center' body={initiatorEditPopUpAction} style={{ maxWidth: '3rem', }}></Column>
                                                            </DataTable> :
                                                            <div className="card flex justify-content-center">
                                                                < ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration="2s" />
                                                            </div>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                        {/*---Preview Section---*/}
                                        <div className="mt-[1.250vw]">
                                            <div className="flex flex-wrap justify-between items-center">
                                                <div className="">
                                                    <Link to={(EditByAP == "EditBySA") ? "/time_report/SuperAdminDashboard" : "/time_report"} className="text-xs xl:text-[0.938vw] font-medium inline-block bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] text-[#344054] rounded xl:rounded-lg py-[0.833vw] px-[2.217vw] box-shadow-2"><i className="mr-1 gusd-arrow-line-right"></i>Back</Link></div>
                                                {
                                                    visible &&
                                                        reportId ?
                                                        <div className="space-x-4">

                                                            {<button
                                                                onClick={
                                                                    () => {
                                                                        setPreviewVisible(true);
                                                                        onClickPreview();
                                                                    }
                                                                }
                                                                // onClick={handlePrint}
                                                                // onClick={handlePrint}
                                                                className="font-medium inline-block text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#3366FF] hover:bg-[#3366FF] border border-[#D0D5DD] text-[#FFF]"><i className="mr-1 gusd-eye"></i>Preview</button>}

                                                            {(currentStatus === "PENDING" || EditByAP==="copyReport") ?
                                                                <Link onClick={() => saveReport(Request_Status.P)} className="inline-block text-[#2D5BE5] text-xs xl:text-[0.938vw] font-medium border border-[#D0D5DD] bg-[#EFF8FF] rounded xl:rounded-lg py-[0.833vw] px-[2.448vw]"><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>
                                                                : null
                                                            }
                                                            <Link onClick={() => {
                                                                setVisibleDialogue(true)
                                                            }} className="font-medium inline-block text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.448vw] box-shadow-2 rounded xl:rounded-lg bg-[#113699] hover:bg-[#0f296e] text-white border border-[#F2F4F7]"><i className="mr-1 gusd-check"></i>Submit</Link>


                                                        </div>
                                                        : <div className="space-x-4">

                                                            <Link onClick={() => saveReport(Request_Status.P)} className="inline-block text-[#2D5BE5] text-xs xl:text-[0.938vw] font-medium border border-[#D0D5DD] bg-[#EFF8FF] hover:bg-[#EFF8FF] rounded xl:rounded-lg py-[0.833vw] px-[2.048vw]"><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>
                                                            <Link onClick={() => {
                                                                if (account == "") { toast.error("Please Enter Account # Number"); setEmpDisable(false); return }
                                                                else if (rateType === null) { toast.error("Please Select Rate Type."); setEmpDisable(false); return }
                                                                else if (pageNo === "") { toast.error("Please Select Page No."); setEmpDisable(false); return }
                                                                else if (!isHourlyRate && dailyRate === "") { toast.error("Please Daily Rate."); setEmpDisable(false); return }
                                                                else if (firstApproval === null) { toast.error("Please Select Principal/ Dept Head."); setEmpDisable(false); return }

                                                                if (budgetClerk) {
                                                                    if (secondApproval === null) { toast.error("Please Select Budget Manager."); return false; }
                                                                }

                                                                setVisibleDialogue(true)
                                                            }} className="font-medium inline-block text-[#FFFFFF] text-xs xl:text-[0.938vw] py-[0.833vw] px-[2.048vw] box-shadow-2 rounded xl:rounded-lg bg-[#113699] hover:bg-[#0f296e] border border-[#F2F4F7]"><i className="mr-1 gusd-check"></i>Submit</Link>

                                                        </div>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-span-12 lg:col-span-4">
                                        <div className="bg-white box-shadow-1 p-4 rounded-lg xl:p-[0.833vw]">
                                            <div className="text-[#101828] font-semibold text-base xl:text-[0.833vw]"><p>Selected Dates</p></div>
                                            {
                                                isShowSelectedDate &&
                                                selectedDateRecord.map((currentItem, i) => {

                                                    return (
                                                        <div key={i} id={`delete_${i}`}>

                                                            <div className="mt-[24px] xl:mt-[1.250vw]">
                                                                <div className="text-[#344054] font-normal text-xs xl:text-[0.625vw] flex flex-wrap items-center justify-between lg:flex-nowrap gap-2"><p className="w-full lg:w-[7.813vw] text-[11px] font-bold">{moment(currentItem.displayDate).format("D MMMM YYYY")}</p><span className="w-full h-[1px] bg-[#E4E7EC] inline-block"></span>
                                                                    <div onClick={() => removeDiv(i)} className=' top-2 right-5'><i
                                                                        class="pi pi-trash printicon text-[gray]"></i></div>
                                                                        {currentItem.isWrong?<i className="pi pi-ban" style={{ color: 'red' }}></i>:<></>}
                                                                         </div>



                                                            </div>
                                                            <div className="mt-[16px] xl:mt-[0.833vw]">
                                                                <div className="bg-[#F2F4F7] rounded p-2 xl:p-[0.417vw] custseledate">
                                                                    <div className="p-[8px] flex gap-5 mt-[5px] xl:mt-[0.380vw] xl:p-[0.417vw]">
                                                                        <div className="flex flex-wrap gap-3">
                                                                            {
                                                                                <div className="">
                                                                                    <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Hours<span className='text-[red] '>*</span></label>
                                                                                    <div className="flex">
                                                                                        <div className="relative custinput-h">
                                                                                            <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC]"><p>H</p></div>
                                                                                            <InputNumber
                                                                                                value={currentItem.totalHour}
                                                                                                maxLength={1} max="8"
                                                                                                onValueChange={(e) => { onClickHoure(i, e.target.value) }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                        <div className="flex flex-wrap gap-3">
                                                                            {
                                                                                <div className="">
                                                                                    <label htmlFor="username" className="text-[#344054] text-xs xl:text-[0.625vw] font-semibold -tracking-[0.02em]">Minutes<span className='text-[red] '>*</span></label>
                                                                                    <div className="flex">
                                                                                        <div className="relative custinput-h">
                                                                                            <div className="bg-[#F2F4F7] flex items-center justify-center absolute right-[0rem] top-[0.1rem] text-[0.75rem] font-normal text-[#818C95] w-[1.563rem] h-[1.35rem] border border-[#E4E7EC]"><p>M</p></div>
                                                                                            {
                                                                                                currentItem.totalHour === 8 ?
                                                                                                    <InputNumber
                                                                                                        disabled={true}
                                                                                                        value={currentItem.minutes}
                                                                                                        maxLength={2}
                                                                                                        max="59"
                                                                                                        className="bg-[#ffffff00] h-[1.35rem]" /> : <InputNumber
                                                                                                        value={currentItem.minutes}
                                                                                                        maxLength={2}
                                                                                                        max="59"
                                                                                                        onChange={(e) => {
                                                                                                            onClickMinutes(i, e.value)
                                                                                                        }} className="bg-[#ffffff00] h-[1.35rem]" />
                                                                                            }

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            {
                                                selectedDateRecord >= 0 ? null : <div className="custbutn mt-6 xl:mt-[1.250vw]">
                                                    <Button className="" label={showPleaseWaitButton ? 'Please wait...' : 'Apply'} onClick={() => {
                                                        applyReport()
                                                    }}>
                                                    </Button>
                                                </div>
                                            }
                                        </div>

                                    </div>
                                    <div className="dialogpoput flex justify-content-center ">
                                        <Dialog visible={visibleDialogue} position="center" style={{ width: '30vw' }} className="dialogpoput dialogres submit_popup" onHide={() => setVisibleSumbit(false)}>

                                            <div className="text-[#101828] text-lg py-2 pt-5 font-bold text-center">Submit Report</div>
                                            <div className="text-[#344054] text-xs pb-2 font-medium">Your report will be sent for review, you will be notified of updates.</div>

                                            <div className="pt-2 flex pb-[-2px] justify-center gap-2">
                                                <Link href={''} className="custmBtn3 rounded-lg text-[black] text-center bg-[White]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                }}
                                                > Cancel
                                                </Link>
                                                <Link href={''} className="custmBtn3 rounded-lg text-[#FFFFFF] text-center bg-[#113699]" onClick={() => {
                                                    setVisibleDialogue(false)
                                                    saveReport(Request_Status.S)
                                                    // submitReport()
                                                }}
                                                >Send
                                                </Link>
                                            </div>

                                        </Dialog>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                {/* preview Dialog */}
                {/* <Dialog header="Time Report Detailed Preview" visible={previewVisible} style={{ width: '85vw' }} onHide={() => setPreviewVisible(false)}
                footer={footerContent}
                > */}

                {/* empTableData: empTableData, */}

                {
                    previewVisible === true && specificReportDetailsView.length > 0 ?
                        <div style={{ display: "none" }} className='content-container'>
                            <div ref={componentRef}
                            // className='printTable'
                            //  id='divnames'
                            >
                                <div id="my-html-template" className='border px-8'>
                                    <center style={{ marginTop: '10px' }}>GLENDALE UNIFIED SCHOOL DISTRICT
                                        <div className='font-bold'>Time Report</div>
                                    </center>
                                    <div>
                                        <div className='flex justify-between'>
                                            <div className='border'>
                                                <div>Account # <span>{(account) ? '$ ' + account + ' USD' : '_________'}</span></div>
                                                <div>Daily Rate <span>{(dailyRate) ? '$ ' + dailyRate + ' USD' : '______'}</span>  or Hourly Rate <span>{(hourlyRate) ? '$ ' + hourlyRate + ' USD' : '_____'}</span></div>
                                                <div className='flex gap-x-4'>
                                                    <div>Authorizing Board Report Date <span>{(authorizingBoardReportDate) ? moment(authorizingBoardReportDate).format('MM-DD-YYYY') : '_____'}</span></div>
                                                    <div>Page No. <span>{(pageNo) ? pageNo : '_____'}</span></div>
                                                </div>
                                                <div>Type  <span>{(rateType) ? rateType.name : '_____'}</span></div>
                                            </div>
                                            <div className='border'>
                                                <div>School or Dept. <span>{(selectedSchool) ? selectedSchool.name : '_____'}</span></div>
                                                <div>Period From  <span>{(periodDates.length > 0) ? moment(periodDates[0]).format("MM-DD-YYYY") + ' to ' + moment(periodDates[1]).format("MM-DD-YYYY") : '__________'}</span> </div>
                                            </div>
                                        </div>

                                        <div className='border mt-2'>
                                            <div>Notes. <span>{(notes) ? notes : '_____'}</span></div>
                                        </div>

                                        {/* <div className='border border-[black] my-4'>
                                            <div className='text-center font-bold'><span>{(periodDates.length > 0) ? moment(periodDates[0]).format("MM-DD-YYYY") + ' to ' + moment(periodDates[1]).format("MM-DD-YYYY") : '_______________'}</span></div>
                                            <div>
                                                <table className='w-full border my-3'>
                                                    <tr>
                                                        <th className='border border-[black] text-left' colspan="2" >Employee details</th>
                                                        {
                                                            months.map((item) => {
                                                                return (
                                                                    <th className='border border-[black] text-center' colspan={datesLength[item]}  >{moment(item, "MM").format("MMMM")}  </th>
                                                                );
                                                            })
                                                        }
                                                        <th className='border border-[black] text-center'
                                                            rowspan={2}
                                                        // rowspan={totalRowspan.length > 0 ? Math.abs(totalRowspan[0] - dates.length) > 0 ? Math.abs(totalRowspan[0] - dates.length) : "1" : "1"}
                                                        >Total Hrs </th>
                                                    </tr>
                                                    <tr>
                                                        <th className='border border-[black] text-left'>Sr No.</th>
                                                        <th className='border border-[black] text-left'>Emp Name</th>
                                                        {
                                                            dates.map((currentItem) => {
                                                                return (
                                                                    <th className='border border-[black] text-center'>{moment(currentItem).format("DD")}</th>
                                                                );
                                                            })
                                                        }
                                                    </tr>
                                                    {
                                                        (specificReportDetailsView) ?
                                                            (specificReportDetailsView).map((item, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className='border border-[black] '>{i + 1}</td>
                                                                        <td className='border border-[black]'>{item.employeeName}</td>
                                                                        {
                                                                            item.employeeResponseArray.map((currentItem) => {
                                                                                return (
                                                                                    <td className='border border-[black] text-center'>{currentItem.totalHourAndMinutesDisplay}</td>
                                                                                );
                                                                            })
                                                                        }

                                                                        {item.restTdCount ?

                                                                            Array.from(Array(item.restTdCount)).map(() => <td className='border border-[black] text-center'></td>)


                                                                            : null}
                                                                        <td className='border border-[black] text-center'>{item.totalEmployeeWorkingHours}</td>
                                                                    </tr>
                                                                );
                                                            }) : null
                                                    }

                                                </table>



                                            </div>
                                        </div> */}

                                        <><DataRow periodDates={periodDates} months={months} datesLength={datesLength} totalRowspan={totalRowspan} dates={dates} specificReportDetailsView={specificReportDetailsView} start={0} end={16} pageNo={1} /></>
                                        {
                                            (pages).map((item) => {
                                                return (
                                                    <>
                                                        <DataRow periodDates={periodDates} months={months} datesLength={datesLength} totalRowspan={totalRowspan} dates={dates} specificReportDetailsView={item.empTableData} start={item.start} end={item.end} pageNo={item.pageNo} />
                                                    </>
                                                );

                                            })
                                        }

                                    </div>
                                </div>
                            </div>
                        </div> : null
                }


                {/*    <HtmlToPdfTimeReport
                        specificReportDetails={specificReportDetailsView}
/> */}
                {/* </Dialog> */}
            </Layout >
        </>

    ) : (
        <Login sessionExpired={1} />
    );
}

export default InitiateNewTimeReport


const DataRow = ({ periodDates, months, datesLength, totalRowspan, dates, specificReportDetailsView, start, end, pageNo }) => {
    return (
        <>
            <table className='w-full border border-[black] my-3'>
                <thead>
                    <tr>
                        <th colspan={dates?.length + 3}>{(periodDates.length > 0) ? moment(periodDates[0]).format("MM/DD/YYYY") + ' to ' + moment(periodDates[1]).format("MM/DD/YYYY") : '_______________'}</th>
                    </tr>
                    <tr>
                        <th className='border border-[black] text-left' colspan="2" >Employee details</th>
                        {
                            months.map((item) => {
                                return (
                                    <th className='border border-[black] text-center' colspan={datesLength[item]}  >{moment(item, "MM").format("MMMM")}  </th>
                                );
                            })
                        }
                        <th className='border border-[black] text-center'
                            rowspan={2}
                        // rowspan={totalRowspan.length > 0 ? Math.abs(totalRowspan[0] - dates.length) > 0 ? Math.abs(totalRowspan[0] - dates.length) : "1" : "1"}
                        >Total Hrs </th>
                    </tr>
                    <tr>
                        <th className='border border-[black] text-left'>Sr No.</th>
                        <th className='border border-[black] text-left'>Emp Name</th>
                        {
                            dates.map((currentItem) => {
                                return (
                                    <th className='border border-[black] text-center'>{moment(currentItem).format("DD")}</th>
                                );
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        (specificReportDetailsView) ?
                            (specificReportDetailsView).map((item, i) => {
                                if (i >= start && i < end) {
                                    return (
                                        <tr>
                                            <td className='border border-[black] '>{i + 1}</td>
                                            <td className='border border-[black]'>{item.employeeName}</td>
                                            {
                                                item.employeeResponseArray.map((currentItem) => {
                                                    return (
                                                        <td className='border border-[black] text-center'>{currentItem.totalHourAndMinutesDisplay}</td>
                                                    );
                                                })
                                            }

                                            {item.restTdCount ?
                                                Array.from(Array(item.restTdCount)).map(() => <td className='border border-[black] text-center'></td>)
                                                : null}
                                            <td className='border border-[black] text-center'>{item.totalEmployeeWorkingHours}</td>
                                        </tr>
                                    );
                                }
                            }) : null
                    }
                </tbody>
            </table>
            {/* <div className='text-center page-numbers'>Page No {pageNo}</div> */}
        </>
    )
};

